/* eslint-disable no-useless-escape */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { environment as environmentConfig } from '../../../environments/environment';
import { CommonBindingDataService } from './services/common-binding-data.service';

const environment: any = environmentConfig;

@Injectable()
export class AppSettings {

  constructor(private commonBindingDataService: CommonBindingDataService) {

  }
  public static BASE_URL = environment.basePath;
  public static BASE_URL_CUSTOMER = environment.basePathCustomer;
  public static IS_IDLE_TIME = environment.idleTimeEnable;
  // public static IDLE_TIME = 60000;
  //public static IDLE_TIME_ON_CONFIRM_MSG = 60000;
 

  public static BASE_BROWSER_URL = environment.baseBrowserUrl;
  public static mapKey = environment.mapKey;
  public static DEFAULT_COUNTRY_CODE = environment.countryCode;
  public static LOGIN_SECRET = environment.loginSecret;
  public static SUPPORTED_COUNTRY: ['IN'];
  public static SUPPORTED_MAP_CENTER_LAT: '40.7127753';
  public static SUPPORTED_MAP_CENTER_LONG: '-74.0059728';
  public static IDLE_TIME = 288; // one day min
  public static IDLE_TIME_DAYS = 3; // 3 days
  public static IDLE_TIME_ON_CONFIRM_MSG = 240000;
  public static INTERVAL = 'interval';
  public static IDLE_POLL_INTERVAL_MS = 30000;
  public static SEARCH_DELAY_INTERVAL = 1000;
  public static HEADER_CONTENT_TYPE = 'application/json';
  public static HEADER_AUTHORIZATION = 'Authorization';
  public static HEADER_TIMEZONE = 'Timezone';
  public static HEADER_TIMEZONE_VALUE = '';
  public static HEADER_ACCEPT_LANGUAGE = 'en-US';
  public static HEADER_AUTHORIZATION_VALUE = '';
  public static USER = null;
  public static TOKEN_KEY = 'Token';
  public static USER_DETAILS = 'userDetails';
  public static ORDER_DETAILS = 'orderDetails';
  public static FOOD_EXTRA_MAPPING = 'foodExtraMapping';
  public static FOOD_EXTRA_SELECTED = 'foodExtraSelected';
  public static MENU_ITEM_SELECTED = 'MenuItemSelected';
  public static MENU_ITEMS_FOR_TEMPLATE = 'MenuItemsForTemplate';
  public static MENU_ITEMS_SELECTED_FOR_TEMPLATE = 'MenuItemSelectedForTemplate';
  public static FOOD_EXTRA_FOR_MENU_ITEM_SELECTED = 'foodExtraForMenuItemSelected';
  public static EVENT_FORM_RAW_DATA = 'eventFormRawData';
  public static TEMPLATE_FORM_RAW_DATA = 'templateFormRawData';
  public static MENU_LIST_FOR_STORAGE = 'menuListForStorage';
  public static PREV_MENU_TREE_STRUCTURE = 'previousMenuTreeStructure';
  public static DASHBOARD_TIME_BASED_BODY = 'dashboardTimeBasedBody';
  public static EVENT_FORM_LATEST_POLYGON = 'latestPoligonCoOrdinates';
  public static EVENT_FORM = 'eventForm';
  public static DONATION_ORDER_DETAILS = 'donationOrderDetails';
  public static USER_DETAILS_NAME = 'user_details_name';
  public static USER_DETAILS_EMAIL = 'user_details_email';
  public static USER_DETAILS_USER_PROFILE = 'userProfile';
  public static USER_DETAILS_LOGIN_DATA = 'loginData';
  public static USER_DETAILS_PROFILE_TIMEZONE = 'userProfileTimeZone';
  public static USER_DETAILS_LOGIN_USER_ID = 'loginUserId';
  public static USER_SETTINGS_DATA = 'userSettingsData';
  public static USER_ROLE_FRANCHISE = 'Franchise';
  public static USER_ROLE_ADMIN = 'Admin';
  public static USER_ROLE_MANAGER = 'Manager';
  public static USER_ROLE_OWNER_STAFF = 'Owner Staff';
  public static START_DAY_OF_WEEK_FOR_MONTH = 'startDayOfWeekForMonth';
  public static MERGE_CLIENT_DATA = 'mergeClientData';
  public static GRID_OFFSET = 'gridOffset';
  public static GRID_LIMIT_RECORDS = 'recordsPerPage';
  public static WEBSITE_URL_TOMS = 'https://travelintomscoffee.com/';

  public static FILE_UPLOAD_ID = '';
  public static FILE_UPLOAD_NAME = '';
  public static PROFILE_UPLOAD_ID = '';
  public static PROFILE_UPLOAD_NAME = '';
  public static FAQ = null;
  public static ACCESS_LIST = 'ACCESS_LIST';
  public static ACCESS_MENU = 'ACCESS_MENU';
  public static TIME_SETTINGS = 'TIME_SETTINGS';
  public static DOWNLOAD_ID = 'DOWNLOAD_ID';
  public static MIN_DISTANCE = 0.1;
  public static MAX_DISTANCE = 1;
  public static MIN_PERCENT = 0;
  public static MIN_INVOICE_DAYS = 1;
  public static MAX_INVOICE_DAYS = 100;
  public static MIN_STAFF_EDITING_DISABLED_DAYS = 0;
  public static MAX_STAFF_EDITING_DISABLED_DAYS = 100;
  public static MAX_PERCENT = 100;
  public static MILES_METER_CONVERSION = 1609.4;
  // public static UPLOAD_FILE_URL = AppSettings.BASE_URL + '/secure/file';
  public static UPLOAD_FILE_URL = AppSettings.BASE_URL + '/secure/files?type=profile';
  public static GET_FILE_URL = AppSettings.BASE_URL + '/file';
  public static GET_FILE_THUMB_URL = AppSettings.BASE_URL + '/file/thumbnail_';
  public static EXPORT_URL = AppSettings.BASE_URL + '/';
  public static PRINT_URL = AppSettings.BASE_URL + '/';
  public static DEFAULT_PROFILE_IMAGE_URL = '/assets/images/default_profile.png';
  public static DEFAULT_USER_IMAGE = 'assets/images/default_user.png';
  public static DEFAULT_NO_IMAGE = 'assets/images/dummy_image150.png';


  public static DEFAULT_COUNTRY_STRING = 'USA';
  public static DEFAULT_COUNTRY_STRING_PAYMENT = 'US';
  public static DEFAULT_TIME_ZONE_FROM_CONFIG = 'America/Chicago';
  public static DEFAULT_SCHEDULE_WITHOUT_ASSET_COLOR = '#C9C8C8';
  public static DEFAULT_EQUIPMENT_WITHOUT_COLOR = '#33FF00';
  public static DEFAULT_UNASSIGNED = 'UNASSIGNED';
  public static DEFAULT_ALL_VALUE = 'ALL';

  public static Store = '+1';
  public static CLEAR_NOTIFICATION_INTERVAL: any;
  public static NOTIFICATION_INTERVAL: 600;
  public static VERSION_INTERVAL:number = 900000; // 15 minutes
  public static IGNORE_LINK = [];

  public static EVENT_DETAILS = 'eventDetails';
  public static EVENTS_LIST: any;
  public static SELECTED_PRODUCT = 'selectedProduct';
  public static SELECTED_SLOTS: any;
  public static SELECTED_MENU_FOR_FE = 'selectedProductForFoodExtra';
  public static SELECTED_MAIN_MENU_LIST = 'selectedMainMenuList';
  public static ORDER_ID = 'orderId';
  public static CUSTOMER_DATA = 'customerDetails';
  public static WEBSITE_PATTERN = new RegExp([
    '^(http://www\\.|https://www\\.|http://|https://)?',
    '[a-z0-9]+([\\-.]{1}[a-z0-9]+)*\\.[a-z]{2,5}(:[0-9]{1,5})?',
    '(/.*)?$'
  ].join(''));
  public static NAME_PATTERN = new RegExp(['^[A-Za-z\\d\\-_\\s]*$'].join(''));
  public static ROLE_PATTERN = new RegExp(['^[A-Za-z\\d\\-_\\s/\\\\\]*$'].join(''));
  public static PHONE_PATTERN = '^[0-9][0-9]*$';
  public static NUMBER_PATTERN = /^\+?[0-9\-]+$/;
  public static NUMBER_WITHOUT_SPECIAL_PATTERN = /^\+?\d+$/;
  public static AMOUNT_PATTERN = new RegExp(['^[0-9\\d\.]*$'].join(''));
  public static NUMBER_FOUR_DECIMAL = new RegExp(/^\d*\.?\d{0,4}$/);
  public static PERCENT_PATTERN = /^100(.00)?|([1-9]?\d{1,2})(\.\d{2})?$/;
  public static PHONE_CODE = /(\d{4,})|[1-9]/;
  public static MOBILE_PATTERN = '^([0-9]+-)*[0-9]+$';
  // public static EMAIL_PATTERN = new RegExp(['[a-z|A-Z|0-9]+[@]+[a-z|A-Z|0-9]+[.]+[a-z|A-Z|0-9]+'].join(''));
  // public static EMAIL_PATTERN = new RegExp(['/^\S+@\S+\.\S+$/'].join(''));
  public static MULTI_EMAIL_PATTERN = '^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,})(, [a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,})*';
  public static PASSWORD_VALIDATIONS = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,20}$/;
  public static EMAIL_PATTERN = new RegExp(['^\\s*(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@',
    '((\\[[\\d]{1,3}\\.[\\d]{1,3}\\.[\\d]{1,3}\\.[\\d]{1,3}])|(([a-zA-Z\\-\\d]+\\.)+[a-zA-Z]{2,15}))\\s*$'].join(''));
  public static NO_WHITESPACE = new RegExp(['.*[^ ].*'].join(''));
  public static ZIPCODE_PATTERN = new RegExp(['^[0-9]'].join(''));
  public static MULTI_ZIPCODE_PATTERN = '^[0-9]{5}(,[0-9]{5})*$';
  public static DIGIT_PATTERN = new RegExp(['^[\\d]*$'].join(''));
  public static RADIUS_DIGIT_PATTERN = /^[0-9|.]+$/;
  public static MIN_MAXIMUM_SHIFT_DURATION = 1;
  public static MAX_MAXIMUM_SHIFT_DURATION = 24;
  public static DEFAULT_MAXIMUM_SHIFT_DURATION = 24;
  public static NUMBER_NOT_ZERO = new RegExp(['^[1-9][0-9]*$'].join(''));
  public static FEE_PATTERN = new RegExp(['^\\d+(\.\\d{1,2})?$'].join(''));
  public static ALPHA_NUMERIC = new RegExp(['^[A-Za-z0-9]'].join(''));
  public static VALUE_ONE_TO_HUNDRED = new RegExp(['^[1-9][0-9]?$|^100$'].join(''));
  // public static VALUE_0_TO_999 = new RegExp(['^[0-9][0-9]{0,2}$|^\d$'].join(''));
  public static VALUE_0_TO_999 = new RegExp(['^(16[0-8]|1[01][0-9]|[1-9]?[0-9])$'].join(''));
  public static NON_ZERO_VALUES = new RegExp(['^[1-9][0-9]*$'].join(''));
  public static HOTEL_PROFILE_UPLOAD_ID = '';
  public static HOTEL_PROFILE_UPLOAD_NAME = '';
  public static PERSON_NAME_PATTERN = '^[a-zA-Z][a-zA-Z\\s\-\_]+$';
  public static COMPANY_AND_PERSON_NAME_PATTERN = '^[a-zA-Z0-9][a-zA-Z0-9\\s\-\_]+$';
  public static FAX_PATTERN = /^\+?[0-9\-]+$/;
  public static TIME_ZONE_FIRST_STRING = /[(]/gi;
  public static TIME_ZONE_SECOND_STRING = /\)/gi;

  public static DOMAIN_VALUES = {
    KONA: environment.brandIds.kona.domain,
    KONA_BRAND_ID: environment.brandIds.kona.brandId,
    TOMS: environment.brandIds.toms.domain,
    TOMS_BRAND_ID: environment.brandIds.toms.brandId,
    ANNS: environment.brandIds.anns.domain,
    ANNS_BRAND_ID: environment.brandIds.anns.brandId,
  };

  public static ENVIRONMENT = environment.ENVIRONMENT;
  public static ENVIRONMENT_TYPE_DEV = 'dev';
  public static ENVIRONMENT_TYPE_DEMO = 'demo';
  public static ENVIRONMENT_TYPE_PROD = 'prod';
  public static HMAC_VALUES = {
    HEADER_WEB: 'WEB',
    DHEMO1AC: environment.DHEMO1AC,
    DHEMO2AC: '5jBQq2lD6LPCjNR',
    DHEVM1AC: environment.DHEVM1AC,
    DHEVM2AC: '5jBQq2lD6LPCjNR',
    PHRMO1AC: environment.PHRMO1AC,
    PHRMO2AC: 'WQRasdf156afRWR',
    DOMAIN_LOCAL: 'localhost',
    DOMAIN_DEV: 'devapi.konaos.com',
    DOMAIN_DEMO: 'demoapi.konaos.com',
    DOMAIN_PROD: 'api.konaicepay.com',
  };



  public static DAYS_COLLECTION = [
    { label: 'Sun', value: '1' },
    { label: 'Mon', value: '2' },
    { label: 'Tue', value: '3' },
    { label: 'Wed', value: '4' },
    { label: 'Thu', value: '5' },
    { label: 'Fri', value: '6' },
    { label: 'Sat', value: '7' }
  ];

  public static LOGGED_IN_ROLE = '';
  public static roles = [
    {
      roleCode: 'System Admin',
      redirect: '/admin-dashboard'
    }
  ];

  public static STAFF_ROLES = {
    'Driver': 'Driver',
    'Manager': 'Manager',
    'Server': 'Server',
    'Worker': 'Worker',
  };

  public static TEMPLATE_TYPES = [
    { label: 'Select', value: '' },
    { label: 'General Inquiry', value: 'General Inquiry' },
    { label: 'School', value: 'School' },
    { label: 'Corporate', value: 'Corporate' },
    { label: 'Youth Sports', value: 'Youth Sports' },
    { label: 'Daycare', value: 'Daycare' },
    { label: 'Party', value: 'Party' }
  ];

  public static BOOKING_FORM_TEMPLATE_TYPES = [
    { label: 'Select', value: '' },
    { label: 'Corporate', value: 'Corporate' },
    { label: 'Athletics', value: 'Athletics' },
    { label: 'Church', value: 'Church' },
    { label: 'Daycare', value: 'Daycare' },
    { label: 'Education', value: 'Education' },
    { label: 'Festival', value: 'Festival' },
    { label: 'Community', value: 'Community' },
    { label: 'Private', value: 'Private' },
    { label: 'Other', value: 'Other' }
  ];

  public static TEMPLATE_TYPES_DEFAULT = [
    { label: 'Default', value: 'Default' }
  ];

  public static DATE_FORMATTER = 'MMM DD, YYYY hh:mm A';

  public static COOKIE_EXPIRY = (1 * 24 * 60 * 60 * 1000);

  public static FILE_UPLOAD_MAX_SIZE_IN_BYTE = 10000000;

  public static FILE_UPLOAD_MAX_SIZE_FOR_ASSETS_IN_BYTE = 3000000;
  public static FILE_UPLOAD_MAX_SIZE_FOR_MAIL_ATTACHMENTS_IN_BYTE = 5242880; // 5MB 
  public static FILE_UPLOAD_MAX_SIZE_FOR_SIGNATURE_IN_BYTE = 2000000;

  //10mb for no_reply email template
  public static FILE_UPLOAD_MAX_SIZE_FOR_NOREPLY_MAIL_ATTACHMENTS_IN_BYTE = 5500000;

  public static SESSION_KEY_NAME = 'X-SESSION-KEY';

  public static COUNTRY_CODE = [
    { label: '+1', value: '+1' },
    { label: '+7', value: '+7' },
    { label: '+20', value: '+20' },
    { label: '+27', value: '+27' },
    { label: '+30', value: '+30' },
    { label: '+31', value: '+31' },
    { label: '+32', value: '+32' },
    { label: '+33', value: '+33' },
    { label: '+34', value: '+34' },
    { label: '+36', value: '+36' },
    { label: '+39', value: '+39' },
    { label: '+40', value: '+40' },
    { label: '+41', value: '+41' },
    { label: '+43', value: '+43' },
    { label: '+44', value: '+44' },
    { label: '+45', value: '+45' },
    { label: '+46', value: '+46' },
    { label: '+47', value: '+47' },
    { label: '+48', value: '+48' },
    { label: '+49', value: '+49' },
    { label: '+51', value: '+51' },
    { label: '+52', value: '+52' },
    { label: '+53', value: '+53' },
    { label: '+54', value: '+54' },
    { label: '+55', value: '+55' },
    { label: '+56', value: '+56' },
    { label: '+57', value: '+57' },
    { label: '+58', value: '+58' },
    { label: '+60', value: '+60' },
    { label: '+61', value: '+61' },
    { label: '+62', value: '+62' },
    { label: '+63', value: '+63' },
    { label: '+64', value: '+64' },
    { label: '+65', value: '+65' },
    { label: '+66', value: '+66' },
    { label: '+81', value: '+81' },
    { label: '+82', value: '+82' },
    { label: '+84', value: '+84' },
    { label: '+86', value: '+86' },
    { label: '+90', value: '+90' },
    { label: '+91', value: '+91' },
    { label: '+92', value: '+92' },
    { label: '+93', value: '+93' },
    { label: '+94', value: '+94' },
    { label: '+95', value: '+95' },
    { label: '+98', value: '++98' },
    { label: '+212', value: '+212' },
    { label: '+213', value: '+213' },
    { label: '+216', value: '+216' },
    { label: '+218', value: '+218' },
    { label: '+220', value: '+220' },
    { label: '+221', value: '+221' },
    { label: '+222', value: '+222' },
    { label: '+223', value: '+223' },
    { label: '+224', value: '+224' },
    { label: '+225', value: '+225' },
    { label: '+226', value: '+226' },
    { label: '+227', value: '+227' },
    { label: '+228', value: '+228' },
    { label: '+229', value: '+229' },
    { label: '+230', value: '+230' },
    { label: '+231', value: '+231' },
    { label: '+232', value: '+232' },
    { label: '+233', value: '+233' },
    { label: '+234', value: '+234' },
    { label: '+235', value: '+235' },
    { label: '+236', value: '+236' },
    { label: '+237', value: '+237' },
    { label: '+238', value: '+238' },
    { label: '+239', value: '+239' },
    { label: '+240', value: '+240' },
    { label: '+241', value: '+241' },
    { label: '+242', value: '+242' },
    { label: '+243', value: '+243' },
    { label: '+244', value: '+244' },
    { label: '+245', value: '+245' },
    { label: '+248', value: '+248' },
    { label: '+249', value: '+249' },
    { label: '+250', value: '+250' },
    { label: '+251', value: '+251' },
    { label: '+252', value: '+252' },
    { label: '+253', value: '+253' },
    { label: '+254', value: '+254' },
    { label: '+255', value: '+255' },
    { label: '+256', value: '+256' },
    { label: '+257', value: '+257' },
    { label: '+258', value: '+258' },
    { label: '+260', value: '+260' },
    { label: '+261', value: '+261' },
    { label: '+262', value: '+262' },
    { label: '+263', value: '+263' },
    { label: '+264', value: '+264' },
    { label: '+265', value: '+265' },
    { label: '+266', value: '+266' },
    { label: '+267', value: '+267' },
    { label: '+268', value: '+268' },
    { label: '+269', value: '+269' },
    { label: '+290', value: '+290' },
    { label: '+291', value: '+291' },
    { label: '+297', value: '+297' },
    { label: '+298', value: '+298' },
    { label: '+299', value: '+299' },
    { label: '+350', value: '+350' },
    { label: '+351', value: '+351' },
    { label: '+352', value: '+352' },
    { label: '+353', value: '+353' },
    { label: '+355', value: '+355' },
    { label: '+356', value: '+356' },
    { label: '+357', value: '+357' },
    { label: '+358', value: '+358' },
    { label: '+359', value: '+359' },
    { label: '+370', value: '+370' },
    { label: '+371', value: '+371' },
    { label: '+372', value: '+372' },
    { label: '+373', value: '+373' },
    { label: '+374', value: '+374' },
    { label: '+375', value: '+375' },
    { label: '+376', value: '+376' },
    { label: '+377', value: '+377' },
    { label: '+378', value: '+378' },
    { label: '+380', value: '+380' },
    { label: '+381', value: '+381' },
    { label: '+382', value: '+382' },
    { label: '+385', value: '+385' },
    { label: '+386', value: '+386' },
    { label: '+387', value: '+387' },
    { label: '+389', value: '+389' },
    { label: '+420', value: '+420' },
    { label: '+421', value: '+421' },
    { label: '+423', value: '+423' },
    { label: '+500', value: '+500' },
    { label: '+501', value: '+501' },
    { label: '+502', value: '+502' },
    { label: '+503', value: '+503' },
    { label: '+504', value: '+504' },
    { label: '+505', value: '+505' },
    { label: '+506', value: '+506' },
    { label: '+507', value: '+507' },
    { label: '+508', value: '+508' },
    { label: '+509', value: '+509' },
    { label: '+590', value: '+590' },
    { label: '+591', value: '+591' },
    { label: '+592', value: '+592' },
    { label: '+593', value: '+593' },
    { label: '+595', value: '+595' },
    { label: '+597', value: '+597' },
    { label: '+598', value: '+598' },
    { label: '+670', value: '+670' },
    { label: '+672', value: '+672' },
    { label: '+673', value: '+673' },
    { label: '+674', value: '+674' },
    { label: '+675', value: '+675' },
    { label: '+676', value: '+676' },
    { label: '+677', value: '+677' },
    { label: '+678', value: '+678' },
    { label: '+679', value: '+679' },
    { label: '+680', value: '+680' },
    { label: '+681', value: '+681' },
    { label: '+682', value: '+682' },
    { label: '+683', value: '+683' },
    { label: '+685', value: '+685' },
    { label: '+686', value: '+686' },
    { label: '+687', value: '+687' },
    { label: '+688', value: '+688' },
    { label: '+689', value: '+689' },
    { label: '+690', value: '+690' },
    { label: '+691', value: '+691' },
    { label: '+692', value: '+692' },
    { label: '+850', value: '+850' },
    { label: '+852', value: '+852' },
    { label: '+853', value: '+853' },
    { label: '+855', value: '+855' },
    { label: '+856', value: '+856' },
    { label: '+870', value: '+870' },
    { label: '+880', value: '+880' },
    { label: '+886', value: '+886' },
    { label: '+960', value: '+960' },
    { label: '+961', value: '+961' },
    { label: '+962', value: '+962' },
    { label: '+963', value: '+963' },
    { label: '+964', value: '+964' },
    { label: '+965', value: '+965' },
    { label: '+966', value: '+966' },
    { label: '+967', value: '+967' },
    { label: '+968', value: '+968' },
    { label: '+971', value: '+971' },
    { label: '+972', value: '+972' },
    { label: '+973', value: '+973' },
    { label: '+974', value: '+974' },
    { label: '+975', value: '+975' },
    { label: '+976', value: '+976' },
    { label: '+977', value: '+977' },
    { label: '+992', value: '+992' },
    { label: '+993', value: '+993' },
    { label: '+994', value: '+994' },
    { label: '+995', value: '+995' },
    { label: '+996', value: '+996' },
    { label: '+998', value: '+998' }
  ];

  public static EVENT_LINK_CONSTANT = 'https://konaschoolsidedev.mi2.in/#/events/';
  public static MESSAGE_TYPE = { SUCCESS: 'success', ERROR: 'error', WARNING: 'warning', INFO: 'info' };
  public static DUMMY_VEHICLES_FILTER = [
    { label: 'All', value: '' },
    { label: 'Actual', value: 'ACTUAL' },
    { label: 'Dummy', value: 'DUMMY' },
  ];

  public static RECORDS_PER_PAGE_OPTIONS = [
    { label: '10', value: 10 },
    { label: '20', value: 20 },
    { label: '30', value: 30 },
  ];

  public static ZIP_CODE_MAX_LENGTH = 5;
  public static ZIP_CODE_MIN_LENGTH = 5;
  public static ADDRESS_MAX_LENGTH = 100;
  public static twentyThreeFiftyNineLapse = 86399000;
  public static ORDER_STATUS_LIST = [
    { label: 'New', value: 'NEW' },
    { label: 'In Progress', value: 'IN_PROGRESS' },
    { label: 'Completed', value: 'COMPLETED' },
    { label: 'Cancelled', value: 'CANCELLED' },
  ];
  public static ORDER_STATUS_LIST_FILTER_OPTIONS = [
    { label: 'All', value: '' },
    { label: 'New', value: 'NEW' },
    { label: 'In Progress', value: 'IN_PROGRESS' },
    { label: 'Completed', value: 'COMPLETED' },
    { label: 'Cancelled', value: 'CANCELLED' },
  ];

  public static DAYS_LIST_FILTER_OPTIONS = [
    { label: '30 Days', value: '30' },
    { label: '60 Days', value: '60' },
    { label: '90 Days', value: '90' },
    { label: 'Custom', value: 'custom' },
  ];
  public static MESSAGE_RECEIVER_OPTIONS = [
    { label: 'Franchise Only', value: ['3f3c80363afa4bcdabe1e366c0289ce3',] },
    { label: 'Everyone', value: ['3f3c80363afa4bcdabe1e366c0289ce3', 'fe9018580813488eb8fa9759dc72fc84'] },
  ];

  public static PAYMENT_STATUS_LIST_FILTER_OPTIONS = [
    { label: 'All', value: '' },
    { label: 'Pending', value: 'PENDING' },
    { label: 'Success', value: 'SUCCESS' },
    { label: 'Partial Refund Success', value: 'PARTIAL REFUND SUCCESS' },
    { label: 'Refund Success', value: 'REFUND SUCCESS' },
    { label: 'Refund Failed', value: 'REFUND FAILED' },
    { label: 'Invoice', value: 'INVOICE' },
    { label: 'On Site', value: 'ONSITE' },
    { label: 'Invoice Refund', value: 'INVOICE REFUND' },
    { label: 'On Site Refund', value: 'ONSITE REFUND' },
    { label: 'Failed', value: 'FAILED' },
  ];

  public static ORDER_PLATFORM_LIST = [
    { label: 'All', value: 'all' },
    { label: 'POS', value: 'pos' },
    { label: 'Prepay', value: 'prepay' },
  ];

  public static ORDER_PLATFORM_LIST1 = [
    { label: 'All', value: '' },
    { label: 'POS', value: 'pos' },
    { label: 'Prepay', value: 'prepay' },
  ];


  public static ORDER_STATUS_LIST_BULK_CHANGE_OPTIONS = [
    { label: 'In Progress', value: 'IN_PROGRESS' },
    { label: 'Completed', value: 'COMPLETED' },
  ];

  public static DELIVERY_OPTIONS = [
    { label: 'Delivery', value: 'DELIVERY' },
    { label: 'Pickup', value: 'PICKUP' },
  ];

  public static DELIVERY_VALUES = {
    DELIVERY: 'DELIVERY',
    PICKUP: 'PICKUP'
  };

   public static BRAND_NAME_VALUES = {
    KONA: 'Kona Ice',
    TOMS: 'Travelin\' Tom\'s',
    BEVERLY_ANNS: 'Beverly Ann\'s'
  };

  public static EVENT_HOLD_OPEN_VALUES = {
    HOLD: 'HOLD',
    OPEN: 'OPEN'
  };

  public static EMAIL_TEMPLATE_TYPES = {
    BOOKING: 'BOOKING',
    CONFIRMATION: 'CONFIRMATION',
    THANKYOU: 'THANKYOU',
    CUSTOM: 'CUSTOM'
  };

  public static COUNTRY_LIST = [
    { label: 'United States of America', value: 'USA' },
  ];

  public static EVENTS_STATUS_LIST_FILTER_OPTIONS = [
    { label: 'All Events and Tasks', value: 'allEventsAndTask', disabled: false },
    { label: 'All Events', value: '', disabled: false },
    { label: 'All Tasks', value: 'allTasks', disabled: false },
    // { label: 'Active', value: 'Active' ,disabled: false },
    { label: 'Deleted Event', value: 'Deleted', disabled: false },
    // { label: 'Deleted Task', value: 'deletedTask' ,disabled: false },
    { label: 'PrePay Event', value: 'PrePayEvent', disabled: false },
    { label: 'Kurbside Event', value: 'KurbsideEvent', disabled: false },
  ];

  public static EVENTS_STATUS_LIST_FILTER_VALUES = {
    All_EVENTS_AND_TASK: 'allEventsAndTask',
    All_EVENTS: '',
    All_TASK: 'allTasks',
    DELETED_TASK: 'deletedTask',
  };

  public static STATUS_LIST_FILTER_OPTIONS = [
    { label: 'All', value: '' },
    { label: 'POS Customer', value: 'true' },
    { label: 'Prepay Customer', value: 'false' },
  ];

  public static GENERAL_STATUS_LIST_FILTER_OPTIONS = [
    { label: 'All', value: '' },
    { label: 'Active', value: 'true' },
    { label: 'Inactive', value: 'false' },
  ];

  public static MIGRATION_TYPE_LIST_FILTER_OPTIONS = [
    { label: 'All', value: '' },
    { label: 'Copy', value: 'Copy' },
    { label: 'Move', value: 'Move' },
    { label: 'Aggregate', value: 'Aggregate' },
  ];

  public static YES_NO_OPTIONS = [
    { label: 'No', value: false },
    { label: 'Yes', value: true },
  ];

  public static READ_UNREAD_OPTIONS = [
    { label: 'All', value: '' },
    { label: 'Unread', value: false },
    { label: 'Read', value: true },
  ];

  public static FBR_EVENT_TYPE_OPTIONS = [
    { label: 'General Inquiry', value: 'General Inquiry' },
    { label: 'School', value: 'School' },
    { label: 'Corporate', value: 'Corporate' },
    { label: 'Youth Sports', value: 'Youth Sports'},
    { label: 'Daycare', value: 'Daycare' },
    { label: 'Party', value: 'Party' },
    
    { label: 'Education', value: 'Education' },
    { label: 'Athletics', value: 'Athletics' },
    { label: 'Church', value: 'Church' },
    { label: 'Community', value: 'Community' },
    { label: 'Festival', value: 'Festival' },
    { label: 'Private', value: 'Private'},
    { label: 'Other', value: 'Other' },
  ];

  public static FBR_MANUAL_STATUS_OPTIONS = [
    { label: 'Pending', value: 'pending' ,disabled: false},
    { label: 'Contacted', value: 'contacted' ,disabled: false},
    { label: 'Awaiting Details', value: 'awaiting_details' ,disabled: false},
    { label: 'Complete', value: 'complete' ,disabled: false},
    { label: 'Deleted', value: 'deleted' ,disabled: false},
  ];

   public static ENQUIRY_EVENT_SOURCE_OPTIONS = [
    { label: 'Events', value: 'system', disabled: false ,srcImg: './assets/images/new_icons/events_icon_new.png'},
    { label: 'No Replies', value: 'no-reply', disabled: false ,srcImg: './assets/images/new_icons/no_reply.png'},
    { label: 'Gmail AI Widget', value: 'gmail-widget', disabled: false ,srcImg: './assets/images/action_icons/email_icon.png'},
    { label: 'AI Booking Form', value: 'booking-form', disabled: false ,srcImg: './assets/images/ai/konaAI_v4.png'},
    { label: 'Manual Entry', value: 'manual-no-reply', disabled: false ,srcImg: './assets/images/new_icons/no_reply.png'},
  ];

  public static CAMPAIGN_COMMENTS_OPTIONS = [
    { label: 'No', value: 'NO' },
    { label: 'Most Recent', value: 'Most Recent' },
    { label: 'From Top Donors', value: 'From Top Donors' },
  ];

  public static ADD_FOOD_EXTRA_ITEM_SLECTION_OPTIONS = [
    { label: 'Single', value: 'single' },
    { label: 'Multiple', value: 'multiple' },
  ];

  public static ccPercentCharges = 2;

  public static EVENT_TYPE_OPTIONS = [
    { label: 'Private', value: 'private' },
    { label: 'Public', value: 'public' },
  ];

  public static ADMIN_TIME_SLOTS_OPTIONS = [
    { label: 'Select', value: '' },
    { label: '10', value: 10 },
    { label: '15', value: 15 },
    { label: '30', value: 30 },
    { label: '60', value: 60 },
  ];

  public static PAYMENT_TERMS_OPTIONS = [
    { label: 'Menu', value: 'menu' },
    { label: 'Invoice', value: 'invoice' },
    { label: 'On Site', value: 'onsite' },
  ];

  public static MONTH_START_DAY_OPTIONS = [
    { label: 'Sunday-Saturday', value: 0 },
    { label: 'Monday-Sunday', value: 1 },
  ];

  public static DASHBOARD_RECORDS_BY = [
    { label: 'Today', value: 'daily' },
    { label: 'This Week', value: 'weekly' },
    { label: 'This Month', value: 'monthly' },
  ];

  public static CLIENT_INDUSTRY = [
    { label: 'IT', value: 'IT' },
    { label: 'Mecahnical', value: 'Mecahnical' },
  ];

  public static TASK_FREQUENCY = [
    { label: 'Do Not Repeat', value: 'DNR' },
    // { label: 'Daily', value: 'daily' },
    { label: 'Weekdays (Mon-Fri)', value: 'weekdays' },
    { label: 'Weekly', value: 'weekly' },
    { label: 'Monthly', value: 'monthly' },
    { label: 'Custom', value: 'custom' },
  ];

  //newly added for #165
  public static EVENT_FREQUENCY = [
    { label: 'Do Not Repeat', value: 'DNR' },
    { label: 'Daily', value: 'daily' },
    { label: 'Weekly', value: 'weekly' },
    { label: 'Monthly', value: 'monthly' },
    { label: 'Weekdays (Mon-Fri)', value: 'weekdays' },
    { label: 'Bi-Weekly', value: 'biweekly' },
    { label: 'Custom', value: 'custom' },
  ];

  public static CUSTOM_RECURRING = [
    { label: 'Day', value: 'day' },
    { label: 'Week', value: 'weekly' },
    { label: 'Month', value: 'monthly' },
  ];

  public static EVENT_DISPLAY_TYPE = [
    { label: 'List', value: 'list', disabled: false },
    { label: 'Day', value: 'day', disabled: false },
    { label: 'Week', value: 'week', disabled: false },
    { label: 'Month', value: 'month', disabled: false },
  ];

  public static EVENT_DISPLAY_TYPE_VALUES = {
    LIST: 'list',
    DAY: 'day',
    WEEK: 'week',
    MONTH: 'month'
  };

  public static WEEKDAYS = [
    { label: 'S', value: 'SUN' },
    { label: 'M', value: 'MON' },
    { label: 'T', value: 'TUE' },
    { label: 'W', value: 'WED' },
    { label: 'T', value: 'THU' },
    { label: 'F', value: 'FRI' },
    { label: 'S', value: 'SAT' },
  ];


  public static STAFF_SCHEDULE_TIME_SLOT = [
    { label: '00:00', value: '00:00' },
    { label: '00:15', value: '00:15' },
    { label: '00:30', value: '00:30' },
    { label: '00:45', value: '00:45' },
    { label: '01:00', value: '01:00' },
    { label: '01:15', value: '01:15' },
    { label: '01:30', value: '01:30' },
    { label: '01:45', value: '01:45' },
    { label: '02:00', value: '02:00' },
    { label: '02:15', value: '02:15' },
    { label: '02:30', value: '02:30' },
    { label: '02:45', value: '02:45' },
    { label: '03:00', value: '03:00' },

  ];

  public static contactTypes = [
    { label: 'Primary', value: 'primary' },
    { label: 'Secondary', value: 'secondary' },
    { label: 'Other', value: 'other' },
  ];

  public static EVENT_STATUS_LIST = [
    { label: 'Pending', value: 'pending' ,disabled: false},
    { label: 'Booked', value: 'booked' ,disabled: false},
    { label: 'Confirmed', value: 'confirmed' ,disabled: false},
    { label: 'Cancelled', value: 'cancelled' ,disabled: false},
    { label: 'Transferred', value: 'transferred' ,disabled: false},
    { label: 'Flagged', value: 'flagged' ,disabled: false},
    { label: 'Skipped', value: 'skipped' ,disabled: false},
    { label: 'Waitlist', value: 'waitlist' ,disabled: false},
  ];

  public static EMAIL_STATUS_LIST = [
    { label: 'Booking email not sent', value: 'bookedEmailSent' },
    { label: 'Confirmation email not sent', value: 'confirmedEmailSent' },
    { label: 'Thank you email not sent', value: 'thankYouEmail' },
    { label: 'Invoice not sent', value: 'clientInvoice' },
    { label: 'Invoice not paid', value: 'invoiceNotPaid' },
    { label: 'Giveback not sent', value: 'givebackPaid' },
    { label: 'Giveback not settled', value: 'givebackNotSettled' },


  ];

  public static SALES_TYPE_OPTIONS = {
    // { label: 'Collected amounts', value: 'collected' },
    // { label: 'Package fee', value: 'package_fee' },
    // { label: 'cup count', value: 'cup_count' },
    'collected': 'aafc6f2ff133458e84e4d88495ac6446',
    'package_fee': '046a441cbc6e48029620228a990893bb',
    'cup_count': '1368a9a8ece845dc85cd032ddf745000',
  };

  public static STAFF_STATUS_LIST_FILTER_OPTIONS = [
    { label: 'Hours Worked Summary', value: 'HOURS WORKED SUMMARY' },
    { label: 'Employee Time Card', value: 'EMPLOYEE TIME CARD' },
    { label: 'Employee Shift Card', value: 'EMPLOYEE SHIFT CARD'}
  ];

  public static DISCREPANCY_MINUTES_MIN_OPTIONS = [
    { label: 'All', value: 0 ,disabled: false},
    { label: '15 Minutes', value: 15 ,disabled: false},
    { label: '30 Minutes', value: 30 ,disabled: false},
    { label: '45 Minutes', value: 45 ,disabled: false},
    { label: '1 Hour', value: 60 ,disabled: false},
  ];

  public static STAFF_STATUS = {
    HOURS_WORKED_SUMMARY: 'HOURS WORKED SUMMARY',
    EMPLOYEE_TIME_CARD: 'EMPLOYEE TIME CARD',
    EMPLOYEE_SHIFT_CARD: 'EMPLOYEE SHIFT CARD'
  };

  public static TIMESTATUS_LIST_FILTER_OPTIONS = [
    { label: 'All', value: 'All' },
    { label: 'Reviewed', value: 'Reviewed' },
    { label: 'Unreviewed', value: 'Unreviewed' },
  ];

  public static TIMESTATUS_LIST_FILTER_OPTIONS1 = [
    { label: 'All', value: '' },
    { label: 'Reviewed', value: 'Reviewed' },
    { label: 'Unreviewed', value: 'Unreviewed' },
  ];

  public static YEARS_OPTIONS = [
    { label: 'Lookback 2 Years', value: '2' },
    { label: 'Lookback 3 Years', value: '3' },
    { label: 'Lookback 4 Years', value: '4' },
    { label: 'Lookback 5 Years', value: '5' },
  ];

  public static TIMEFRAME_LIST_FILTER_OPTIONS = [
    { label: 'Today', value: 'TODAY' },
    { label: 'Yesterday', value: 'LAST DAY' },
    { label: 'Last Week', value: 'WEEK' },
    { label: 'Last Month', value: 'MONTH' },
    { label: 'Last Quarter', value: 'QUARTER' },
    { label: 'Last Year', value: 'YEAR' },
    { label: 'This Month', value: 'THIS MONTH' },
    { label: 'This Year', value: 'THIS YEAR' },
    { label: 'Date Range', value: '' },
  ];

  public static SCHEDULE_REPORT_TIMEFRAME_LIST_OPTIONS = [
    { label: 'Today', value: 'Today' },
    { label: 'Yesterday', value: 'LastDay' },
    { label: 'Last Week', value: 'LastWeek' },
    { label: 'Last Month', value: 'LastMonth' },
    { label: 'Last Quarter', value: 'LastQuarter' },
    { label: 'Last Year', value: 'LastYear' },
    { label: 'This Month', value: 'ThisMonth' },
    { label: 'This Year', value: 'ThisYear' },
    { label: 'Date Range', value: 'DateRange' },
  ];

  public static SCHEDULE_REPORT_TIMEFRAME_LIST_OPTIONS_VALUES = {
    TODAY: 'Today',
    LAST_DAY: 'LastDay',
    LAST_WEEK: 'LastWeek',
    LAST_MONTH: 'LastMonth',
    LAST_QUARTER: 'LastQuarter',
    LAST_YEAR: 'LastYear',
    THIS_MONTH: 'ThisMonth',
    THIS_YEAR: 'ThisYear',
    DATE_RANGE: 'DateRange',
  };

  public static TIMEFRAME_LIST_REBOOK_REPORT = [
    { label: 'Week', value: 'WEEK' },
    { label: 'Month', value: 'MONTH' },
    { label: 'Year', value: 'YEAR' },
  ];

  public static TIMEFRAME_LIST_FILTER_OPTIONS_VALUES = {
    TODAY: 'TODAY',
    LAST_DAY: 'LAST DAY',
    WEEK: 'WEEK',
    MONTH: 'MONTH',
    QUARTER: 'QUARTER',
    YEAR: 'YEAR',
    THIS_MONTH: 'THIS MONTH',
    THIS_YEAR: 'THIS YEAR',
    DTE_RANGE: '',
  };

  public static DASHBOARD_TIMEFRAME_LIST_FILTER_OPTIONS = [
    { label: 'Today', value: 'TODAY' },
    { label: 'Last Week', value: 'WEEK' },
    { label: 'Last Month', value: 'MONTH' },
    { label: 'Last Quarter', value: 'QUARTER' },
    { label: 'Last Year', value: 'YEAR' },
    { label: 'This Week', value: 'THIS WEEK' }, // extra added
    { label: 'This Month', value: 'THIS MONTH' },
    { label: 'This Quarter', value: 'THIS QUARTER' },
    { label: 'This Year', value: 'THIS YEAR' },
    { label: 'Month to Date', value: 'MONTH TO DATE' },
    { label: 'Year to Date', value: 'YEAR TO DATE' },
    { label: 'Date Range', value: 'DATE RANGE' },
  ];

  public static SUPERADMIN_REPORT_TIMEFRAME_LIST_FILTER_OPTIONS = [
    { label: 'Last Month', value: 'MONTH' },
    { label: 'Last Quarter', value: 'QUARTER' },
    { label: 'Last Year', value: 'YEAR' },
    { label: 'Date Range', value: '' },
  ];


  public static DASHBOARD_COMPAIR_TIMEFRAME_LIST_FILTER_OPTIONS = [
    { label: 'Previous Period', value: 'YESTERDAY' },
    { label: 'Previous Month', value: 'PREVIOUS MONTH' },
    { label: 'Previous Quarter', value: 'PREVIOUS QUARTER' },
    { label: 'Previous Year', value: 'PREVIOUS YEAR' },
    { label: 'No Comparison', value: 'NO COMPARISON' },
  ];

  public static STAFF_LIST_FILTER_OPTIONS = [
    { label: 'Ganesh Patil', value: 'Ganesh Patil' },
    { label: 'Ketan Tambekar', value: 'Ketan Tambekar' },
  ];

  public static DEFAULT_STAFF_TYPE = 'HOURS WORKED SUMMARY';

  public static SALES_OPTION_LIST_FILTER_OPTIONS = [
    { label: 'Event Sales', value: 'GIVEBACK' },
    { label: 'Event Sales w/ Equipment', value: 'SALES HISTORY' },
    { label: 'Sales Summary', value: 'SALES SUMMARY' },
  ];

  public static EVENT_GRAPHICS_OPTION_LIST_FILTER_OPTIONS = [
    { label: 'Event Flyers Report', value: 'EVENT FLYERS REPORT' },
    { label: 'Event Graphics Report', value: 'EVENT GRAPHICS REPORT' },
  ];

  public static DATABASE_OVERVIEW_OPTION_LIST_FILTER_OPTIONS = [
    { label: 'Customer Report', value: 'CUSTOMER REPORT' },
    { label: 'Event Report', value: 'EVENT REPORT' },
  ];

  public static DEFAULT_SALE_REPORT_TYPE = 'GIVEBACK';

  public static DASHBOARD_LIST_TIMEFRAME_FILTER = [
    { label: 'Today', value: 'today' },
    { label: 'This Week', value: 'weekly' },
    { label: 'This Month', value: 'monthly' },
    { label: 'This Year', value: 'yearly' },
    { label: 'Date Range', value: '' },
  ];
  public static DASHBOARD_LIST_TIMEFRAME_FILTER_TASK = [
    { label: 'Today', value: 'today' },
    { label: 'This Week', value: 'weekly' },
    { label: 'This Month', value: 'monthly' },
    { label: 'This Year', value: 'yearly' },
    { label: 'Date Range', value: '' },
  ];
  public static CUSTOM_RECURRING_WITHOUT_DAY = [
    { label: 'Week', value: 'weekly' },
    { label: 'Month', value: 'monthly' },
  ];

  public static DASHBOARD_GRANULARITY_DAY = [
    { label: 'Daily', value: 'day' }
  ];

  public static DASHBOARD_GRANULARITY_WEEK = [
    { label: 'Daily', value: 'day' },
    { label: 'Weekly', value: 'week' },
  ];

  public static DASHBOARD_GRANULARITY_MONTH = [
    { label: 'Daily', value: 'day' },
    { label: 'Weekly', value: 'week' },
    { label: 'Monthly', value: 'month' },
  ];

  public static DASHBOARD_GRANULARITY_YEAR = [
    { label: 'Weekly', value: 'week' },
    { label: 'Monthly', value: 'month' },
  ];

  public static INVOICE_STATUS_LIST_FILTER_OPTIONS = [
    { label: 'All', value: '' },
    { label: 'Draft', value: 'draft'},
    { label: 'Sent', value: 'sent'},
    { label: 'Paid', value: 'paid'},
    { label: 'Partially Paid', value: 'partial_paid'},
    { label: 'Deposit Paid', value: 'deposit_paid'},
    { label: 'Deposit Overdue', value: 'deposit_overdue'},
    { label: 'Overdue', value: 'overdue'},
    { label: 'Quote Draft', value: 'quotation_draft'},
    { label: 'Quote Sent', value: 'quotation_sent'},
    { label: 'Quote Accepted', value: 'quotation_accepted'},
    { label: 'Quote Rejected', value: 'quotation_rejected'},
    { label: 'Refund', value: 'refunded'},
    { label: 'Partial Refund', value: 'partial_refunded'},
    { label: 'Deleted', value: 'deleted' },
  ];

  public static INVOICE_SOFT_DELETE_FILTER_OPTIONS = [
    { label: 'Active', value: false },
    { label: 'Deleted', value: true },
  ];

  public static INVOICE_REMINDER_OPTIONS = [
    { label: 'Select', value: '' },
    { label: 'Reminder1', value: 'reminder1' },
    { label: 'Reminder2', value: 'reminder2' },
    { label: 'Reminder3', value: 'reminder3' },
  ];

  public static INVOICE_STATUS_FILTER_VALUES = {
     EMPTY:'',
     DRAFT:'draft',
     SENT:'sent',
     PAID:'paid',
     OVERDUE:'overdue',
     PARTIAL_PAID:'partial_paid',
     QUOTATION_DRAFT:'quotation_draft',
     QUOTATION_SENT:'quotation_sent',
     QUOTATION_ACCEPTED:'quotation_accepted',
     QUOTATION_REJECTED:'quotation_rejected',
     REFUND:'refunded',
     PARTIAL_REFUND:'partial_refunded',
     DEPOSIT_PAID:'deposit_paid',
     DEPOSIT_OVERDUE:'deposit_overdue',
  };

  public static INVOICE_TYPE_VALUES = {
    INVOICE: 'invoice',
    QUOTATION: 'quotation',
  };

  public static REBOOK_STATUS_LIST = [
    { label: 'New', value: 'new' },
    { label: 'Won', value: 'won' },
    { label: 'Lost', value: 'lost' },
    { label: 'Working', value: 'working' },
    { label: 'Declined', value: 'declined' },
  ];

  public static REBOOK_STATUS_LIST_VALUES = {
    NEW: 'new',
    WON: 'won',
    LOST: 'lost',
    WORKING: 'working',
    DECLINED: 'declined',
  };
  public static REBOOK_ATTEMPT_LIST = [
    { label: '1', value: '1', id: 1},
    { label: '2', value: '2', id: 2},
    { label: '3', value: '3', id: 3},
    { label: '4', value: '4', id: 4},
    { label: '5', value: '5', id: 5},
  ];

  public static FLYER_NEW_IMAGE_FOLDER_PATH = './assets/images/flyer-templates'
  public static FLYER_NEW_KONA_BRAND_IMAGE_FOLDER_PATH = '/kona';
  public static FLYER_NEW_KONA_BRAND_COUPON_FREE_IMAGE_FOLDER_PATH = '/coupon-free';
  public static FLYER_KONA_PRINT_COUPEN_FREE_OPTIONS = [
    { label: 'KIDDIE KONA', value: 'kiddie',signUrl: `${AppSettings.FLYER_NEW_IMAGE_FOLDER_PATH}${AppSettings.FLYER_NEW_KONA_BRAND_IMAGE_FOLDER_PATH}${AppSettings.FLYER_NEW_KONA_BRAND_COUPON_FREE_IMAGE_FOLDER_PATH}/kiddie.png`},
    { label: 'KLASSIC KONA', value: 'klassic',signUrl: `${AppSettings.FLYER_NEW_IMAGE_FOLDER_PATH}${AppSettings.FLYER_NEW_KONA_BRAND_IMAGE_FOLDER_PATH}${AppSettings.FLYER_NEW_KONA_BRAND_COUPON_FREE_IMAGE_FOLDER_PATH}/regular.png`},
    { label: 'KING KONA', value: 'king',signUrl: `${AppSettings.FLYER_NEW_IMAGE_FOLDER_PATH}${AppSettings.FLYER_NEW_KONA_BRAND_IMAGE_FOLDER_PATH}${AppSettings.FLYER_NEW_KONA_BRAND_COUPON_FREE_IMAGE_FOLDER_PATH}/king.png`},
    { label: 'COLOR CHANGE', value: 'color_changing',signUrl: `${AppSettings.FLYER_NEW_IMAGE_FOLDER_PATH}${AppSettings.FLYER_NEW_KONA_BRAND_IMAGE_FOLDER_PATH}${AppSettings.FLYER_NEW_KONA_BRAND_COUPON_FREE_IMAGE_FOLDER_PATH}/color_changing.png`},
    { label: 'KOWABUNGA', value: 'kowabunga',signUrl: `${AppSettings.FLYER_NEW_IMAGE_FOLDER_PATH}${AppSettings.FLYER_NEW_KONA_BRAND_IMAGE_FOLDER_PATH}${AppSettings.FLYER_NEW_KONA_BRAND_COUPON_FREE_IMAGE_FOLDER_PATH}/souviner.png`},
    { label: 'KOLLECTABLE', value: 'kollectable',signUrl: `${AppSettings.FLYER_NEW_IMAGE_FOLDER_PATH}${AppSettings.FLYER_NEW_KONA_BRAND_IMAGE_FOLDER_PATH}${AppSettings.FLYER_NEW_KONA_BRAND_COUPON_FREE_IMAGE_FOLDER_PATH}/character.png`},
  ];
  public static FLYER_TOMS_PRINT_COUPEN_FREE_OPTIONS = [
    { label: 'Hot Beverage', value: 'hot_beverage',signUrl: `./assets/images/flyer-templates/tom/coupon-free/hot_beverges.png`},
    { label: 'Frozen Beverage', value: 'frozen_beverage',signUrl: `./assets/images/flyer-templates/tom/coupon-free/frozon_beverges.png`},
    { label: 'Beverage line-up', value: 'beverage_line_up',signUrl: `./assets/images/flyer-templates/tom/coupon-free/trio-toms_coupon.png`},
    ];
  public static FLYER_BEV_PRINT_COUPON_FREE_OPTIONS = [
    { label: 'Cookies', value: 'cookies',signUrl: `./assets/images/flyer-templates/bev/coupon-free/Cookie.png`},
    { label: 'Ann Wich', value: 'ann_wich',signUrl: `./assets/images/flyer-templates/bev/coupon-free/Annwich.png`},
  ];
  public static FLYER_BEV_PRINT_HORIZONTAL_OPTIONS = [
    { label: 'Cookies Only', value: 'cookie_only'},
    { label: 'Cookie/Ice Cream/Ann-wich', value: 'cookie_ice_cream_ann_wich'},
  ];
  
  public static FLYER_TYPE_OPTIONS_VALUES = {
  KONA_SOCIAL_DEFAULT: 'kona-social-default',
  KONA_PRINT_DEFAULT: 'kona-print-default',
  TOMS_SOCIAL_DEFAULT: 'toms-social-default',
  TOMS_PRINT_DEFAULT: 'toms-print-default',
  BEV_SOCIAL_DEFAULT: 'bev-social-default',
  BEV_PRINT_DEFAULT: 'bev-print-default',
  KONA_SOCIAL_KONA_COMING_CUP_MENU: 'kona-social-kona-coming-cup-menu',
  KONA_SOCIAL_KONA_COMING_FLAVORWAVE: 'kona-social-kona-coming-flavorwave',
  KONA_PRINT_COUPON_FREE: 'kona-print-coupon-free',
  KONA_PRINT_KONA_COMING_FLAVORWAVE: 'kona-print-kona-coming-flavorwave',
  KONA_PRINT_KONA_COMING_HORIZONTAL: 'kona-print-kona-coming-horizontal',
  TOMS_SOCIAL_TOMS_COMING_CUP_MENU: 'toms-social-toms-coming-cup-menu',
  TOMS_SOCIAL_TOMS_COMING_BEVERAGES: 'toms-social-toms-coming-beverages',
  TOMS_PRINT_COUPON_FREE: 'toms-print-coupon-free',
  TOMS_PRINT_TOMS_COMING_BEVERAGES: 'toms-print-toms-coming-beverages',
  TOMS_PRINT_TOMS_COMING_BEVERAGES_HORIZONTAL: 'toms-print-toms-coming-beverages-horizontal',
  BEV_SOCIAL_BEV_COMING_FULL_MENU: 'bev-social-bev-coming-full-menu',
  BEV_SOCIAL_BEV_COMING_COOKIES_ONLY: 'bev-social-bev-coming-cookies-only',
  BEV_PRINT_COUPON_FREE: 'bev-print-coupon-free',
  BEV_PRINT_BEV_COMING_FULL_MENU: 'bev-print-bev-coming-full-menu',
  BEV_PRINT_BEV_COMING_HORIZONTAL: 'bev-print-bev-coming-horizontal',
  BEV_PRINT_COOKIE_GRAM_3PERPAGE: 'bev-print-cookie-gram-3perpage',
  };

   public static FLYER_FLAVOR_OPTIONS_VALUES = [
    { label: 'Tiger\'s Blood', value: 'Tiger\'s Blood' },
    { label: 'Lucky Lime', value: 'Lucky Lime' },
    { label: 'Blue Raspberry', value: 'Blue Raspberry' },
    { label: 'Watermelon Wave', value: 'Watermelon Wave' },
    { label: 'Groovy Grape', value: 'Groovy Grape' },
    { label: 'Strawberry\'d Treasure', value: 'Strawberry\'d Treasure' },
    { label: 'Island Rush', value: 'Island Rush' },
    { label: 'Ninja Cherry', value: 'Ninja Cherry' },
    { label: 'Monster Mango', value: 'Monster Mango' },
    { label: 'Pina Colada', value: 'Pina Colada' },
  ];

  public static FLYER_CATEGORY_OPTIONS = [
    {
      brandId: AppSettings.DOMAIN_VALUES.KONA_BRAND_ID,
      socialMedia: [
        {
          label: 'Social Media - Default',
          value: 'kona-social-default'
        },
        {
          label: 'Social Media - Menu Options',
          value: 'kona-social-kona-coming-cup-menu'
        },
        {
          label: 'Social Media - Menu Plus Flavorwave',
          value: 'kona-social-kona-coming-flavorwave'
        },
      ],
      printMedia: [{
        label: 'Print Media - 1/3 Page Flyer',
        value: 'kona-print-default'
      },
      {
        label: 'Print Media - Coupon',
        value: 'kona-print-coupon-free'
      },
      {
        label: 'Print Media - Menu Plus Flavorwave',
        value: 'kona-print-kona-coming-flavorwave'
      },
      {
        label: 'Print Media - Menu (horizontal)',
        value: 'kona-print-kona-coming-horizontal'
      }],
    },

    {
      brandId: AppSettings.DOMAIN_VALUES.TOMS_BRAND_ID,
      socialMedia: [{
        label: 'Social Media - Default',
        value: 'toms-social-default'
      },
      {
        label: `Social Media - Beverage Categories`,
        value: 'toms-social-toms-coming-cup-menu'
      },
      {
        label: `Social Media - Flavor Options`,
        value: 'toms-social-toms-coming-beverages'
      }],
      printMedia: [{
        label: 'Print Media - 1/3 Page Flyer',
        value: 'toms-print-default'
      },
      {
        label: 'Print Media - Coupon',
        value: 'toms-print-coupon-free'
      },
      {
        label: `Print Media - Menu Options (vertical)`,
        value: 'toms-print-toms-coming-beverages'
      },
      {
        label: `Print Media - Beverage Categories (horizontal)`,
        value: 'toms-print-toms-coming-beverages-horizontal'
      }],
    },
    {
      brandId: AppSettings.DOMAIN_VALUES.ANNS_BRAND_ID,
      socialMedia: [{
        label: 'Social Media - Default',
        value: 'bev-social-default'
      },
      {
        label: `Social Media - Event Address`,
        value: 'bev-social-bev-coming-full-menu'
      },
      {
        label: `Social Media - Cookie Menu`,
        value: 'bev-social-bev-coming-cookies-only'
      }],
      printMedia: [{
        label: 'Print Media - 1/3 Page Flyer',
        value: 'bev-print-default'
      },
      {
        label: 'Print Media - Coupon',
        value: 'bev-print-coupon-free'
      },
      {
        label: `Print Media - Menu Options`,
        value: 'bev-print-bev-coming-full-menu'
      },
      {
        label: `Print Media - Cookie Menu (horizontal)`,
        value: 'bev-print-bev-coming-horizontal'
      },
      {
        label: `Print Media - Cookie Gram`,
        value: 'bev-print-cookie-gram-3perpage'
      }],
    },
  ];

   public static FLYER_KONA_PRINT_ITEMS = [
    {brandId: AppSettings.DOMAIN_VALUES.KONA_BRAND_ID, name: 'Kiddie', value: 'kiddie', signUrl: './assets/images/flyers/kona_flyer_kiddie.png', price: 5,sequence:1,refillAvail: false,refill:false ,refillPrice:3,iscups:true},
    {brandId: AppSettings.DOMAIN_VALUES.KONA_BRAND_ID, name: 'Klassic', value: 'klassic', signUrl: './assets/images/flyers/kona_flyer_klassic.png', price: 5,sequence:2,refillAvail: false,refill:false ,refillPrice:3,iscups:true},
    {brandId: AppSettings.DOMAIN_VALUES.KONA_BRAND_ID, name: 'King', value: 'king', signUrl: './assets/images/flyers/kona_flyer_king.png', price: 5,sequence:3,refillAvail: false,refill:false ,refillPrice:3,iscups:true},
    {brandId: AppSettings.DOMAIN_VALUES.KONA_BRAND_ID, name: 'Color Changing', value: 'color_changing', signUrl: './assets/images/flyers/kona_flyer_colorChanging.png', price: 5,sequence:4 ,refillAvail: true,refill:false ,refillPrice:3,iscups:true},
    {brandId: AppSettings.DOMAIN_VALUES.KONA_BRAND_ID, name: 'Kollectable', value: 'kollectable', signUrl: './assets/images/flyers/kona_flyer_kollectable.png', price:5,sequence:5 ,refillAvail: true,refill:false ,refillPrice:3,iscups:true},
    {brandId: AppSettings.DOMAIN_VALUES.KONA_BRAND_ID, name: 'Kowabunga', value: 'kowabunga', signUrl: './assets/images/flyers/kona_flyer_kowabunga.png', price:5,sequence:6 ,refillAvail: true,refill:false ,refillPrice:3,iscups:true},
    {brandId: AppSettings.DOMAIN_VALUES.KONA_BRAND_ID, name: 'Pay It Forward', value: 'pay_it_forward', signUrl: './assets/images/flyers/kona_flyer_payitforward.png', price:6,sequence:7 ,refillAvail: false,refill:false ,refillPrice:3,iscups:true},
    {brandId: AppSettings.DOMAIN_VALUES.KONA_BRAND_ID, name: 'Blended Smoothie', value: 'blended_smoothie', signUrl: './assets/images/flyers/kona_flyer_blended_smoothie.png', price: 5,sequence:8,refillAvail: false,refill:false ,refillPrice:3,iscups:true},
    {brandId: AppSettings.DOMAIN_VALUES.KONA_BRAND_ID, name: 'Refill', value: 'refill', signUrl: './assets/images/flyers/kona_flyer_refill.png', price: 5,sequence:9,refillAvail: false,refill:false ,refillPrice:3,iscups:true},
    // {brandId: AppSettings.DOMAIN_VALUES.KONA_BRAND_ID, name: 'Cocoa cup', value: 'cocoa_cup', signUrl: './assets/images/flyers/kona_flyer_cocoa-cup.png', price: 5,sequence:9,refillAvail: false,refill:false ,refillPrice:3,iscups:true},

    {brandId: AppSettings.DOMAIN_VALUES.KONA_BRAND_ID, name: 'Kandy Spoon', value: 'Kandy_spoons', signUrl: './assets/images/flyers/kona_flyer_kandy_spoons.png', price: 5,sequence:10,refillAvail: false,refill:false ,refillPrice:3,iscups:false},
    {brandId: AppSettings.DOMAIN_VALUES.KONA_BRAND_ID, name: 'Sour Powder', value: 'topz_sour', signUrl: './assets/images/flyers/kona_flyer_topz_sour_powder.png', price: 5,sequence:11,refillAvail: false,refill:false ,refillPrice:3,iscups:false},
    {brandId: AppSettings.DOMAIN_VALUES.KONA_BRAND_ID, name: 'Season Pass', value: 'season_pass', signUrl: './assets/images/flyers/kona_flyer_season_pass.png', price: 5,sequence:12,refillAvail: false,refill:false ,refillPrice:3,iscups:false},

    {brandId: AppSettings.DOMAIN_VALUES.ANNS_BRAND_ID, name: 'Cookies', value: 'cookies', signUrl: './assets/images/flyers/kona_flyer_season_pass.png', price: 4,sequence:13,refillAvail: false,refill:false ,refillPrice:3,iscups:false},
    {brandId: AppSettings.DOMAIN_VALUES.ANNS_BRAND_ID, name: 'Ice Cream Price', value: 'ice_cream', signUrl: './assets/images/flyers/kona_flyer_season_pass.png', price: 3,sequence:13,refillAvail: false,refill:false ,refillPrice:3,iscups:false},
    {brandId: AppSettings.DOMAIN_VALUES.ANNS_BRAND_ID, name: '"Ann" Wich', value: 'ann_wich', signUrl: './assets/images/flyers/kona_flyer_season_pass.png', price: 6,sequence:13,refillAvail: false,refill:false ,refillPrice:3,iscups:false}
  ];


  public static GRAPH_SECONDARY_COMPARED_DEFAULT_COLOR = 'rgb(255, 99, 132, 0.7)';
  public static GRAPH_SECONDARY_COMPARED_DEFAULT_BORDER_COLOR = 'rgb(255, 99, 132, 1)';

  public static CLOCK_IN_OUT_REMINDER: any = [
    { label: '00', value: 0 },
    { label: '15', value: 15 },
    { label: '30', value: 30 },
    { label: '45', value: 45 },
    { label: '60', value: 60 },
  ];

  public static EVENT_SALES_REMINDER: any = [
    { label: '00', value: 0 },
    { label: '15', value: 15 },
    { label: '30', value: 30 },
    { label: '45', value: 45 },
    { label: '60', value: 60 },
  ];
  
  public static NOTIFICATION_REMINDER: any = [
    { label: '00', value: '00' },
    { label: '01', value: '01' },
    { label: '02', value: '02' },
    { label: '03', value: '03' },
    { label: '04', value: '04' },
    { label: '05', value: '05' },
    { label: '06', value: '06' },
    { label: '07', value: '07' },
    { label: '08', value: '08' },
    { label: '09', value: '09' },
    { label: '10', value: '10' },
    { label: '11', value: '11' },
    { label: '12', value: '12' },
    { label: '13', value: '13' },
    { label: '14', value: '14' },
    { label: '15', value: '15' },
    { label: '16', value: '16' },
    { label: '17', value: '17' },
    { label: '18', value: '18' },
    { label: '19', value: '19' },
    { label: '20', value: '20' },
    { label: '21', value: '21' },
    { label: '22', value: '22' },
    { label: '23', value: '23' },
    { label: '24', value: '24' },
    { label: '25', value: '25' },
    { label: '26', value: '26' },
    { label: '27', value: '27' },
    { label: '28', value: '28' },
    { label: '29', value: '29' },
    { label: '30', value: '30' },
    { label: '31', value: '31' },
    { label: '32', value: '32' },
    { label: '33', value: '33' },
    { label: '34', value: '34' },
    { label: '35', value: '35' },
    { label: '36', value: '36' },
    { label: '37', value: '37' },
    { label: '38', value: '38' },
    { label: '39', value: '39' },
    { label: '40', value: '40' },
    { label: '41', value: '41' },
    { label: '42', value: '42' },
    { label: '43', value: '43' },
    { label: '44', value: '44' },
    { label: '45', value: '45' },
    { label: '46', value: '46' },
    { label: '47', value: '47' },
    { label: '48', value: '48' },
    { label: '49', value: '49' },
    { label: '50', value: '50' },
    { label: '51', value: '51' },
    { label: '52', value: '52' },
    { label: '53', value: '53' },
    { label: '54', value: '54' },
    { label: '55', value: '55' },
    { label: '56', value: '56' },
    { label: '57', value: '57' },
    { label: '58', value: '58' },
    { label: '59', value: '59' },
    { label: '60', value: '60' },
    { label: '61', value: '61' },
    { label: '62', value: '62' },
    { label: '63', value: '63' },
    { label: '64', value: '64' },
    { label: '65', value: '65' },
    { label: '66', value: '66' },
    { label: '67', value: '67' },
    { label: '68', value: '68' },
    { label: '69', value: '69' },
    { label: '70', value: '70' },
    { label: '71', value: '71' },
    { label: '72', value: '72' },
  ];

  public static Date_Dropdown: any = [
    { label: '1', value: '1' },
    { label: '2', value: '2' },
    { label: '3', value: '3' },
    { label: '4', value: '4' },
    { label: '5', value: '5' },
    { label: '6', value: '6' },
    { label: '7', value: '7' },
    { label: '8', value: '8' },
    { label: '9', value: '9' },
    { label: '10', value: '10' },
    { label: '11', value: '11' },
    { label: '12', value: '12' },
    { label: '13', value: '13' },
    { label: '14', value: '14' },
    { label: '15', value: '15' },
    { label: '16', value: '16' },
    { label: '17', value: '17' },
    { label: '18', value: '18' },
    { label: '19', value: '19' },
    { label: '20', value: '20' },
    { label: '21', value: '21' },
    { label: '22', value: '22' },
    { label: '23', value: '23' },
    { label: '24', value: '24' },
    { label: '25', value: '25' },
    { label: '26', value: '26' },
    { label: '27', value: '27' },
    { label: '28', value: '28' },
    { label: '29', value: '29' },
    { label: '30', value: '30' },


  ];

  public static Hrs_Dropdown: any = [
    { label: '1', value: '1' },
    { label: '2', value: '2' },
    { label: '3', value: '3' },
    { label: '4', value: '4' },
    { label: '5', value: '5' },
    { label: '6', value: '6' },
    { label: '7', value: '7' },
    { label: '8', value: '8' },
    { label: '9', value: '9' },
    { label: '10', value: '10' },
    { label: '11', value: '11' },
    { label: '12', value: '12' },
    { label: '13', value: '13' },
    { label: '14', value: '14' },
    { label: '15', value: '15' },
    { label: '16', value: '16' },
    { label: '17', value: '17' },
    { label: '18', value: '18' },
    { label: '19', value: '19' },
    { label: '20', value: '20' },
    { label: '21', value: '21' },
    { label: '22', value: '22' },
    { label: '23', value: '23' },
    { label: '24', value: '24' },
  ];

  public static Date_Dropdown_Rebook: any = [
    { label: '30', value: '30' },
    { label: '60', value: '60' },
    { label: '90', value: '90' },
  ];

  public static CAMPAIGN_STATUS = [
    { label: 'All', value: '' },
    { label: 'Sent', value: 'sent' },
    { label: 'Scheduled', value: 'schedule' },
    { label: 'Paused', value: 'paused' }
  ];
  public static CALENDAR_VIEWS = {
    daily: 'daily',
    weekly: 'weekly',
    monthly: 'monthly',
    yearly: 'yearly'
  };

  public static TWENTY_MINUTES = '1200000';

  public static MIGRATION_OPTIONS = [
    { label: 'Clients and Events', value: 'Clients and Events' },
    { label: 'Staff', value: 'Staff' },
    { label: 'Equipment', value: 'Equipment' },
    { label: 'Menu', value: 'Menu' },
    { label: 'Legacy', value: 'Legacy' },
    { label: 'No-Reply Data', value: 'No-Reply Data' },
  ];

  public static MIGRATION_TYPES = [
    { label: 'Select', value: null },
    { label: 'Copy', value: 'Copy' },
    { label: 'Move', value: 'Move' },
  ];

  public static TIMEZONE_TIME = '300000';

  public static REMINDER_DROPDOWN = [
    { label: 'On due date', value: '0' },
    { label: '7', value: '7' },
    { label: '14', value: '14' },
    { label: '30', value: '30' },
    { label: '90', value: '90' }
  ];

  public static DUE_DAYS = [
    { label: 'Before', value: 'before' },
    { label: 'After', value: 'after' }
  ];

  public static EMAIL_REMINDERS = [
    { label: 'Select', value: '' },
    { label: 'On Due Date Reminder', value: 'On Due Reminder' },
    { label: 'After Due Date Reminder', value: 'After Reminder' },
    { label: 'Before Due Date Reminder', value: 'Before Reminder' }
  ];

  public static FEE_TYPES_OPTION = [
    { label: 'Percentage', value: 'Percentage' },
    { label: 'Fixed', value: 'Fixed' }
  ];

  public static SCHEDULE_REPORT_TYPE_OPTION = [
    { label: 'Select', value: '' },
    { label: 'Franchise Order Report', value: 'FranchiseOrderReport' },
    { label: 'Payout Report', value: 'PayoutReport' },
    { label: 'Event Sales Report', value: 'EventSalesReport' },
    { label: 'Event Sales With Equipment Report', value: 'EventSalesWithEquipmentReport' },
    { label: 'Equipment Usage Report', value: 'EquipmentUsageReport' },
    { label: 'Client Ranking Report', value: 'ClientRankingReport' },
    { label: 'Hours Worked Summary Report', value: 'HoursWorkedSummaryReport' },
    { label: 'Employee Time Card Report', value: 'EmployeeTimeCardReport' },
    { label: 'Employee Shift Time Card Report', value: 'EmployeeShiftTimeCardReport' },
  ];

  public static SCHEDULE_REPORT_TYPE_VALUES = {
    FRANCHISE_ORDER_REPORT: 'FranchiseOrderReport',
    EVENT_SALES_REPORT: 'EventSalesReport',
    PAYOUT_REPORT: 'PayoutReport',
    EVENT_SALES_WITH_EQUIPMENT_REPORT: 'EventSalesWithEquipmentReport',
    EQUIPMENT_USAGE_REPORT: 'EquipmentUsageReport',
    CLIENT_RANKING_REPORT: 'ClientRankingReport',
    HOURS_WORKED_SUMMARY_REPORT: 'HoursWorkedSummaryReport',
    EMPLOYEE_TIME_CARD_REPORT: 'EmployeeTimeCardReport',
    EMPLOYEE_SHIFT_TIME_CARD_REPORT: 'EmployeeShiftTimeCardReport',
  };

  public static SCHEDULE_REPORT_RECURING_TYPE_OPTION = [
    { label: 'Select', value: '' },
    { label: 'Daily', value: 'daily' },
    { label: 'Weekly', value: 'weekly' },
    { label: 'Bi-Weekly', value: 'biWeekly' },
    { label: 'Monthly', value: 'monthly' },
    { label: 'Quarterly', value: 'quarterly' }
  ];

  public static TIME_ZONE = [
    { label: 'EST', value: 'est' },
    { label: 'CST', value: 'cst' },
    { label: 'MDT', value: 'mdt' },
    { label: 'MST', value: 'mst' },
    { label: 'ADT', value: 'adt' },
    { label: 'HST', value: 'hst' },
  ];

  public static OPERATING_SEASON_START = [
    { label: 'Year Round', value: 'year-round'},
    { label: 'Seasonal Start', value: 'seasonal'}
  ];

  public static OPERATING_SEASON_END = [
    { label: 'Year Round', value: 'yearRound' },
    { label: 'Seasonal End', value: 'endDate' }
  ];

  public static OPERATING_DAYS = [
    { label: 'Monday', value: 'monday' },
    { label: 'Tuesday', value: 'tuesday' },
    { label: 'Wednesday', value: 'wednesday' },
    { label: 'Thursday', value: 'thursday' },
    { label: 'Friday', value: 'friday' },
    { label: 'Saturday', value: 'saturday' },
    { label: 'Sunday', value: 'sunday' },
  ]

  public static HOURS_FORMAT = [
    { label: '1 hour', value: '1' },
    { label: '2 hour', value: '2' },
    { label: '3 hour', value: '3' },
    { label: '4 hour', value: '4' },
    { label: '5 hour', value: '5' },
    { label: '6 hour', value: '6' },
    { label: '7 hour', value: '7' },
    { label: '8 hour', value: '8' },
    { label: '9 hour', value: '9' },
    { label: '10 hour', value: '10' },
    { label: '11 hour', value: '11' },
    { label: '12 hour', value: '12' },
  ];

  public static MINUTES_FORMAT = [
    { label: ':00', value: '00' },
    { label: ':15', value: '15' },
    { label: ':30', value: '30' },
    { label: ':45', value: '45' }
  ];

  public static TIME_FORMAT = [
    { label: 'AM', value: 'am' },
    { label: 'PM', value: 'pm' }
  ];

  public static OFF_HOUR_SURCHARGE = [
    { label: 'No surcharge', value: 'none' },
    { label: 'Determined per request', value: 'variable' },
    { label: 'Set my own price', value: 'custom' },
    { label: '+25%', value: 25 },
    { label: '+50%', value: 50 },
    { label: '+75%', value: 75 },
    { label: '+100%', value: 100 }
  ];

  public static MIN_PREBOOKING = [
    { label: 'No pre-booking required, call any time', value: 'no-prebook' },
    { label: '12 hours', value: '12 hours' },
    { label: '24 hours', value: '24 hours' },
    { label: '36 hours', value: '36 hours' },
    { label: '48 hours', value: '48 hours' },
    { label: 'Response time may vary', value: 'variable' },
  ];

  public static EXTENDED_SURCHARGE = [
    { label: 'No surcharge', value: 'none' },
    { label: 'Determined per request', value: 'variable' },
    { label: 'Set my own price', value: 'custom' },
    { label: '+25%', value: 25 },
    { label: '+50%', value: 50 },
    { label: '+75%', value: 75 },
    { label: '+100%', value: 100 }
  ];

  public static CUP_TYPES = [
    { label: 'Kiddie Kona (9oz)', value: 'kiddie', priceName: 'kiddiePrice', showOnBookingForm: false },
    { label: 'Klassic Kona (12oz)', value: 'klassic', priceName: 'klassicPrice', showOnBookingForm: false },
    { label: 'King Kona (16oz)', value: 'king', priceName: 'kingPrice', showOnBookingForm: false },
    { label: 'Color Changing Cup (16oz)', value: 'colorChange', priceName: 'colorChangePrice', showOnBookingForm: false },
    { label: 'White Stadium Cup (22oz)', value: 'stadium', priceName: 'stadiumPrice', showOnBookingForm: false },
    { label: 'Kollectable Cup (22oz)', value: 'character', priceName: 'characterPrice', showOnBookingForm: false },
    { label: 'Blended (16oz)', value: 'blended', priceName: 'blendedPrice', showOnBookingForm: false }
  ]

  public static NUTRITIONAL_BASES = [
    {
      nutritionName: 'Classic (Pure Cane Sugar)',
      value: 'classic'
    },{
      nutritionName: 'Vita-Blend (Cane Sugar + Stevia)',
      value: 'vitaBlend'
    },{
      nutritionName: 'FruitFirst (Dehydrated pear + pineapple)',
      value: 'fruitfirst'
    },
    {
      nutritionName: 'Blended',
      value: 'blended'
    }
  ];

  public static MENU_PRICES = [
    {
        cupName: 'Kiddie Kona (9oz)',
        value: 'kk9oz'
    },{
        cupName: 'Klassic Kona (12oz)',
        value: 'kk12oz'
    },{
        cupName: 'King Kona (16oz)',
        value: 'kk16oz'
    },
    {
        cupName: 'Color Changing Cup (16oz)',
        value: 'ccc16oz'
    },
    {
        cupName: 'White Stadium Cup (22oz)',
        value: 'wsc22oz'
    },
    {
        cupName: 'Kollectable Cup (22oz)',
        value: 'cc22oz'
    },
    {
      cupName: 'Refills (per cup, any size)',
      value: 'refill'
    }
  ];

  public static DURATION = [
    { label: '1 Hour', value: '1' },
    { label: '2 Hours', value: '2' },
    { label: '3 Hours', value: '3' },
    { label: '4 Hours', value: '4' },
    { label: '5 Hours', value: '5' },
    { label: '6 Hours', value: '6' },
    { label: '7 Hours', value: '7' },
    { label: '8 Hours', value: '8' },
    { label: '9 Hours', value: '9' },
    { label: '10 Hours', value: '10' },
    { label: '11 Hours', value: '11' },
    { label: '12 Hours', value: '12' },
  ];

  public static FLAVORWAVEFLAVORS = [
    { label: 'Ameretto Sour', value: 'ameretto-sour' },
    { label: 'Aprium Rose Sangria', value: 'aprium-rose-sangria' },
    { label: 'Bahama Mama', value: 'bahama-mama' },
    { label: 'Black Cherry', value: 'black-cherry' },
    { label: 'Blackberry Mojito', value: 'blackberry-mojito' },
    { label: 'Blue Bubble Gum', value: 'blue-bubble-gum' },
    { label: 'Blue Coconut', value: 'blue-coconut' },
    { label: 'Blue Raspberry', value: 'blue-raspberry' },
    { label: 'Blueberry + Acai', value: 'blueberry-acai' },
    { label: 'Bourbon Black Cherry', value: 'bourbon-black-cherry' },
    { label: 'Bug Juice', value: 'bug-juice' },
    { label: 'Buttered Beer', value: 'buttered-beer' },
    { label: 'Caramel Apple', value: 'caramel-apple' },
    { label: 'Caramel Macchiato', value: 'caramel-macchiato' },
    { label: 'Caribbean Cherry', value: 'caribbean-cherry' },
    { label: 'Cherry Limeade', value: 'cherry-limeade' },
    { label: 'Citrus Sour Swizzle', value: 'citrus-sour-swizzle' },
    { label: 'Coconut', value: 'coconut' },
    { label: 'Coconut Lime', value: 'coconut-lime' },
    { label: 'Cosmopolitan', value: 'cosmopolitan' },
    { label: 'Cotton Candy Blue', value: 'cotton-candy-blue' },
    { label: 'Cotton Candy Pink', value: 'cotton-candy-pink' },
    { label: 'Cranky Candy Corn', value: 'cranky-candy-corn' },
    { label: 'Cryin’ Key Lime', value: 'cryin-key-lime' },
    { label: 'Daiquiri', value: 'daiquiri' },
    { label: 'Dye-free Blue Raspberry', value: 'dye-free-blue-raspberry' },
    { label: 'Dye-free Groovy Grape', value: 'dye-free-groovy-grape' },
    { label: 'Dye-free Island Rush', value: 'dye-free-island-rush' },
    { label: 'Dye-free Ninja Cherry', value: 'dye-free-ninja-cherry' },
    { label: 'Dye-free Strawberry’d Treasure', value: 'dye-free-strawberryd-treasure' },
    { label: 'Dye-free Tiger’s Blood', value: 'dye-free-tigers-blood' },
    { label: 'Dye-free Wedding Cake', value: 'dye-free-wedding-cake' },
    { label: 'French Vanilla', value: 'french-vanilla' },
    { label: 'French Vanilla Latte', value: 'french-vanilla-latte' },
    { label: 'Green Apple', value: 'green-apple' },
    { label: 'Groovy Grape', value: 'groovy-grape' },
    { label: 'Hawaiian Dreamsicle', value: 'hawaiian-dreamsicle' },
    { label: 'Horchata', value: 'horchata' },
    { label: 'Ice Cream', value: 'ice-cream' },
    { label: 'Island Rush', value: 'island-rush' },
    { label: 'Kiwi Lime Kooler', value: 'kiwi-lime-kooler' },
    { label: 'Kola', value: 'kola' },
    { label: 'Kooky Candy Apple', value: 'kooky-candy-apple' },
    { label: 'Lavender Lemonade', value: 'lavender-lemonade' },
    { label: 'Lemonade', value: 'lemonade' },
    { label: 'Lucky Lime', value: 'lucky-lime' },
    { label: 'Mai Tai', value: 'mai-tai' },
    { label: 'Margarita', value: 'margarita' },
    { label: 'Mermaid', value: 'mermaid' },
    { label: 'Monkey Business', value: 'monkey-business' },
    { label: 'Monster Mango', value: 'monster-mango' },
    { label: 'Moonflower', value: 'moonflower' },
    { label: 'Ninja Cherry', value: 'ninja-cherry' },
    { label: 'Orange Ya Happy?', value: 'orange-ya-happy' },
    { label: 'Paradise Pink Lemon', value: 'paradise-pink-lemon' },
    { label: 'Passion Fruit', value: 'passion-fruit' },
    { label: 'Peach', value: 'peach' },
    { label: 'Piña Colada', value: 'pina-colada' },
    { label: 'Pineapple Cream', value: 'pineapple-cream' },
    { label: 'Pineapple Sunrise', value: 'pineapple-sunrise' },
    { label: 'Pink Bubble Gum', value: 'pink-bubble-gum' },
    { label: 'Pomegranate + Acai', value: 'pomegranate-acai' },
    { label: 'Pucker-up Peach', value: 'pucker-up-peach' },
    { label: 'Raspberry White Chocolate', value: 'raspberry-white-chocolate' },
    { label: 'Red Cream Soda', value: 'red-cream-soda' },
    { label: 'Red Raspberry', value: 'red-raspberry' },
    { label: 'Root Beer', value: 'root-beer' },
    { label: 'Rose Petal Lemonade', value: 'rose-petal-lemonade' },
    { label: 'Scarlet Dragon', value: 'scarlet-dragon' },
    { label: 'Sour Berry Blast', value: 'sour-berry-blast' },
    { label: 'Starfruit Splash', value: 'starfruit-splash' },
    { label: 'Strawberry Cupcake', value: 'strawberry-cupcake' },
    { label: 'Strawberry Kiwi', value: 'strawberry-kiwi' },
    { label: 'Strawberry’d Treasure', value: 'strawberryd-treasure' },
    { label: 'Sweet Caramel Apple', value: 'sweet-caramel-apple' },
    { label: 'Tiger’s Blood', value: 'tigers-blood' },
    { label: 'Tropical Twist', value: 'tropical-twist' },
    { label: 'Unicorn', value: 'unicorn' },
    { label: 'Vanilla Colada', value: 'vanilla-colada' },
    { label: 'Watermelon Mint', value: 'watermelon-mint' },
    { label: 'Watermelon Wave', value: 'watermelon-wave' },
    { label: 'Wedding Cake', value: 'wedding-cake' },
    { label: 'White Wine Spritzer', value: 'white-wine-spritzer' },
  ];

  public static EVENTOPTIONS = [
    { label: 'Birthday Party', value: 'birthday' },
    { label: 'Weddings', value: 'weddings' },
    { label: 'Corporate', value: 'corporate' },
    { label: 'School', value: 'school' },
    { label: 'Youth Sports', value: 'youth-sports' },
    { label: 'Daycare', value: 'daycare' },
    { label: 'Fundraiser', value: 'fundraiser' },
    { label: 'Other', value: 'other' },
    { label: 'Not Available', value: 'n/a' },
  ];

  public static TIMESLOTS = [
    { label: '12:00 AM', value: ':00' },
    { label: '12:30 AM', value: '00:30' },
    { label: '1:00 AM', value: '01:00' },
    { label: '1:30 AM', value: '01:30' },
    { label: '2:00 AM', value: '02:00' },
    { label: '2:30 AM', value: '02:30' },
    { label: '3:00 AM', value: '03:00' },
    { label: '3:30 AM', value: '03:30' },
    { label: '4:00 AM', value: '04:00' },
    { label: '4:30 AM', value: '04:30' },
    { label: '5:00 AM', value: '05:00' },
    { label: '5:30 AM', value: '05:30' },
    { label: '6:00 AM', value: '06:00' },
    { label: '6:30 AM', value: '06:30' },
    { label: '7:00 AM', value: '07:00' },
    { label: '7:30 AM', value: '07:30' },
    { label: '8:00 AM', value: '08:00' },
    { label: '8:30 AM', value: '08:30' },
    { label: '9:00 AM', value: '09:00' },
    { label: '9:30 AM', value: '09:30' },
    { label: '10:00 AM', value: '10:00' },
    { label: '10:30 AM', value: '10:30' },
    { label: '11:00 AM', value: '11:00' },
    { label: '11:30 AM', value: '11:30' },
    { label: '12:00 PM', value: '12:00' },
    { label: '12:30 PM', value: '12:30' },
    { label: '1:00 PM', value: '13:00' },
    { label: '1:30 PM', value: '13:30' },
    { label: '2:00 PM', value: '14:00' },
    { label: '2:30 PM', value: '14:30' },
    { label: '3:00 PM', value: '15:00' },
    { label: '3:30 PM', value: '15:30' },
    { label: '4:00 PM', value: '16:00' },
    { label: '4:30 PM', value: '16:30' },
    { label: '5:00 PM', value: '17:00' },
    { label: '5:30 PM', value: '17:30' },
    { label: '6:00 PM', value: '18:00' },
    { label: '6:30 PM', value: '18:30' },
    { label: '7:00 PM', value: '19:00' },
    { label: '7:30 PM', value: '19:30' },
    { label: '8:00 PM', value: '20:00' },
    { label: '8:30 PM', value: '20:30' },
    { label: '9:00 PM', value: '21:00' },
    { label: '9:30 PM', value: '21:30' },
    { label: '10:00 PM', value: '22:00' },
    { label: '10:30 PM', value: '22:30' },
    { label: '11:00 PM', value: '23:00' },
    { label: '11:30 PM', value: '23:30' }
  ];

  public static PACKAGE_DURATION = [
    { label: '15 Minutes', value: 0.25 },
    { label: '30 Minutes', value: 0.5 },
    { label: '45 Minutes', value: 0.75 },
    { label: '1 Hour', value: 1 },
    { label: '1 Hour 15 Minutes', value: 1.25 },
    { label: '1 Hour 30 Minutes', value: 1.5 },
    { label: '1 Hour 45 Minutes', value: 1.75 },
    { label: '2 Hours', value: 2 },
    { label: '2 Hours 15 Minutes', value: 2.25 },
    { label: '2 Hours 30 Minutes', value: 2.5 },
    { label: '2 Hours 45 Minutes', value: 2.75 },
    { label: '3 Hours', value: 3 },
    { label: '3 Hours 15 Minutes', value: 3.25 },
    { label: '3 Hours 30 Minutes', value: 3.5 },
    { label: '3 Hours 45 Minutes', value: 3.75 },
    { label: '4 Hours', value: 4 },
    { label: '4 Hours 15 Minutes', value: 4.25 },
    { label: '4 Hours 30 Minutes', value: 4.5 },
    { label: '4 Hours 45 Minutes', value: 4.75 },
    { label: '5 Hours', value: 5 },
    { label: '5 Hours 15 Minutes', value: 5.25 },
    { label: '5 Hours 30 Minutes', value: 5.5 },
    { label: '5 Hours 45 Minutes', value: 5.75 },
    { label: '6 Hours', value: 6 },
    { label: '6 Hours 15 Minutes', value: 6.25 },
    { label: '6 Hours 30 Minutes', value: 6.5 },
    { label: '6 Hours 45 Minutes', value: 6.75 },
    { label: '7 Hours', value: 7 },
    { label: '7 Hours 15 Minutes', value: 7.25 },
    { label: '7 Hours 30 Minutes', value: 7.5 },
    { label: '7 Hours 45 Minutes', value: 7.75 },
    { label: '8 Hours', value: 8 },
    { label: '8 Hours 15 Minutes', value: 8.25 },
    { label: '8 Hours 30 Minutes', value: 8.5 },
    { label: '8 Hours 45 Minutes', value: 8.75 },
    { label: '9 Hours', value: 9 }
  ];

  public static TOMMENUITEMS = [
  {
    label: 'Iced Tea',
    value: 'iced-tea',
    price: undefined,
    enabled: true,
    type: {
      label: 'Iced Drinks',
      value: 'cold-drinks',
    },
  },
  {
    label: 'Nitro Cold Brew',
    value: 'nitro-cold-brew',
    price: undefined,
    enabled: true,
    type: {
      label: 'Iced Drinks',
      value: 'cold-drinks',
    },
  },
  {
    label: 'Cold Brew',
    value: 'cold-brew',
    price: undefined,
    enabled: true,
    type: {
      label: 'Iced Drinks',
      value: 'cold-drinks',
    },
  },
  {
    label: 'Iced Macchiato',
    value: 'iced-macchiato',
    price: undefined,
    enabled: true,
    type: {
      label: 'Iced Drinks',
      value: 'cold-drinks',
    },
  },
  {
    label: 'Iced Latte',
    value: 'iced-latte',
    price: undefined,
    enabled: true,
    type: {
      label: 'Iced Drinks',
      value: 'cold-drinks',
    },
  },
  {
    label: 'Tommy Palmer',
    value: 'tommy-palmer',
    price: undefined,
    enabled: true,
    type: {
      label: 'Iced Drinks',
      value: 'cold-drinks',
    },
  },
  {
    label: 'Iced Spiced Chai',
    value: 'iced-spiced-chai',
    price: undefined,
    enabled: true,
    type: {
      label: 'Iced Drinks',
      value: 'cold-drinks',
    },
  },
  {
    label: 'Lemonade',
    value: 'lemonade',
    price: undefined,
    enabled: true,
    type: {
      label: 'Iced Drinks',
      value: 'cold-drinks',
    },
  },
  {
    label: 'Strawberry Acai',
    value: 'strawberry-acai',
    price: undefined,
    enabled: true,
    type: {
      label: 'Iced Drinks',
      value: 'cold-drinks',
    },
  },
  {
    label: 'Peach Mango',
    value: 'peach-mango',
    price: undefined,
    enabled: true,
    type: {
      label: 'Iced Drinks',
      value: 'cold-drinks',
    },
  },
  {
    label: 'Iced Matcha',
    value: 'matcha-cold',
    price: undefined,
    enabled: true,
    type: {
      label: 'Iced Drinks',
      value: 'cold-drinks',
    },
  },
  {
    label: 'Tilt Nitro Energy',
    value: 'tilt-nitro-energy',
    price: undefined,
    enabled: true,
    type: {
      label: 'Iced Drinks',
      value: 'cold-drinks',
    },
  },
  {
    label: 'Frappe',
    value: 'frappe',
    price: undefined,
    enabled: true,
    type: {
      label: 'Frozen Drinks',
      value: 'frozen-drinks',
    },
  },
  {
    label: 'Frozen Hot Chocolate',
    value: 'frozen-hot-chocolate',
    price: undefined,
    enabled: true,
    type: {
      label: 'Frozen Drinks',
      value: 'frozen-drinks',
    },
  },
  {
    label: 'Frozen Berry Tilt',
    value: 'frozen-berry-tilt',
    price: undefined,
    enabled: true,
    type: {
      label: 'Frozen Drinks',
      value: 'frozen-drinks',
    },
  },
  {
    label: 'Frozen Strawberry Acai',
    value: 'frozen-strawberry-acai',
    price: undefined,
    enabled: true,
    type: {
      label: 'Frozen Drinks',
      value: 'frozen-drinks',
    },
  },
  {
    label: 'Frozen Peach Mango',
    value: 'frozen-peach-mango',
    price: undefined,
    enabled: true,
    type: {
      label: 'Frozen Drinks',
      value: 'frozen-drinks',
    },
  },
  {
    label: 'Latte',
    value: 'latte',
    price: undefined,
    enabled: true,
    type: {
      label: 'Hot Drinks',
      value: 'hot-drinks',
    },
  },
  {
    label: 'Cappuccino',
    value: 'cappuccino',
    price: undefined,
    enabled: true,
    type: {
      label: 'Hot Drinks',
      value: 'hot-drinks',
    },
  },
  {
    label: 'Mocha',
    value: 'mocha',
    price: undefined,
    enabled: true,
    type: {
      label: 'Hot Drinks',
      value: 'hot-drinks',
    },
  },
  {
    label: 'Spiced Chai Latte',
    value: 'spiced-chai-latte',
    price: undefined,
    enabled: true,
    type: {
      label: 'Hot Drinks',
      value: 'hot-drinks',
    },
  },
  {
    label: 'Flat White',
    value: 'flat-white',
    price: undefined,
    enabled: true,
    type: {
      label: 'Hot Drinks',
      value: 'hot-drinks',
    },
  },
  {
    label: 'Americano',
    value: 'americano',
    price: undefined,
    enabled: true,
    type: {
      label: 'Hot Drinks',
      value: 'hot-drinks',
    },
  },
  {
    label: 'Hot Chocolate',
    value: 'hot-chocolate',
    price: undefined,
    enabled: true,
    type: {
      label: 'Hot Drinks',
      value: 'hot-drinks',
    },
  },
  {
    label: 'Espresso Shot',
    value: 'espresso-shot',
    price: undefined,
    enabled: true,
    type: {
      label: 'Hot Drinks',
      value: 'hot-drinks',
    },
  },
  {
    label: 'Dirty Chai',
    value: 'dirty-chai',
    price: undefined,
    enabled: true,
    type: {
      label: 'Hot Drinks',
      value: 'hot-drinks',
    },
  },
  {
    label: 'Cinnamon Apple Cider',
    value: 'cinnamon-apple-cider',
    price: undefined,
    enabled: true,
    type: {
      label: 'Hot Drinks',
      value: 'hot-drinks',
    },
  },
  {
    label: 'Macchiato',
    value: 'macchiato',
    price: undefined,
    enabled: true,
    type: {
      label: 'Hot Drinks',
      value: 'hot-drinks',
    },
  },
  {
    label: 'White Chocolate Mocha',
    value: 'white-chocolate-mocha',
    price: undefined,
    enabled: true,
    type: {
      label: 'Hot Drinks',
      value: 'hot-drinks',
    },
  },
  {
    label: 'Matcha',
    value: 'matcha-hot',
    price: undefined,
    enabled: true,
    type: {
      label: 'Hot Drinks',
      value: 'hot-drinks',
    },
  },
  {
    label: 'Syrup Shot',
    value: 'syrup-shot',
    price: undefined,
    enabled: true,
    type: {
      label: 'Extras',
      value: 'extras',
    },
  },
  {
    label: 'Boba',
    value: 'boba',
    price: undefined,
    enabled: true,
    type: {
      label: 'Extras',
      value: 'extras',
    },
  },
  {
    label: 'Shot of Espresso',
    value: 'shot-of-espresso',
    price: undefined,
    enabled: true,
    type: {
      label: 'Extras',
      value: 'extras',
    },
  },
  {
    label: 'Flavor',
    value: 'flavor',
    price: undefined,
    enabled: true,
    type: {
      label: 'Extras',
      value: 'extras',
    },
  },
]

  public static SYRUPFLAVORS = [
    { label: 'French Vanilla', value: 'french-vanilla' },
    { label: 'Caramel', value: 'caramel' },
    { label: 'Salted Caramel', value: 'salted-caramel' },
    { label: 'Mocha', value: 'mocha' },
    { label: 'Hazelnut', value: 'hazelnut' },
    { label: 'Spiced Chai', value: 'spiced-chai' },
    { label: 'White Chocolate', value: 'white-chocolate' },
    { label: 'Honey Blueberry', value: 'honey-blueberry' },
    { label: 'Vanilla Horchata', value: 'vanilla-horchata' },
    { label: 'Pumpkin Pie', value: 'pumpkin-pie' },
    { label: 'Peppermint', value: 'peppermint' },
    { label: 'Berry', value: 'berry' },
    { label: 'Brown Sugar Cinnamon', value: 'brown-sugar-cinnamon' },
    { label: 'Raspberry', value: 'raspberry' },
    { label: 'Peach', value: 'peach' },
  ];

  public static SELECT_ALL_EVENTS = {label: "Available for all event types", value: "all"};
  public static CUP_TYPE_SORT_ORDER = ['kiddie', 'klassic', 'king', 'colorChange', 'stadium', 'character'];
  public static SCHEDULE_REPORT_EXECUTION_DATE = [
    { label: '1st', value: 1 },
    { label: '2nd', value: 2 },
    { label: '3rd', value: 3 },
    { label: '4th', value: 4 },
    { label: '5th', value: 5 },
    { label: '6th', value: 6 },
    { label: '7th', value: 7 },
    { label: '8th', value: 8 },
    { label: '9th', value: 9 },
    { label: '10th', value: 10 },
    { label: '11th', value: 11 },
    { label: '12th', value: 12 },
    { label: '13th', value: 13 },
    { label: '14th', value: 14 },
    { label: '15th', value: 15 },
    { label: '16th', value: 16 },
    { label: '17th', value: 17 },
    { label: '18th', value: 18 },
    { label: '19th', value: 19 },
    { label: '20th', value: 20 },
    { label: '21st', value: 21 },
    { label: '22nd', value: 22 },
    { label: '23rd', value: 23 },
    { label: '24th', value: 24 },
    { label: '25th', value: 25 },
    { label: '26th', value: 26 },
    { label: '27th', value: 27 },
    { label: '28th', value: 28 },
    { label: '29th', value: 29 },
    { label: '30th', value: 30 },
    { label: '31st', value: 31 },
  ]

  public static INVOICE_PAYMENT_STATUS_LIST_FILTER_OPTIONS = [
    { label: 'Invoice Paid - All', value: 'all' },
    { label: 'Invoice Paid - Stripe', value: 'stripe' },
    { label: 'Invoice Paid - Manual', value: 'manual' },
  ];

  public static DEFAULT_ADDITIONAL_FLAVORWAVE_FLAVORS = [
    { label: 'Lucky Lime', value: 'lucky-lime' },
    { label: 'Tiger’s Blood', value: 'tigers-blood' },
    { label: 'Blue Raspberry', value: 'blue-raspberry' },
    { label: 'Watermelon Wave', value: 'watermelon-wave' },
    { label: 'Groovy Grape', value: 'groovy-grape' },
    { label: 'Strawberry’d Treasure', value: 'strawberryd-treasure' },
    { label: 'Island Rush', value: 'island-rush' },
    { label: 'Ninja Cherry', value: 'ninja-cherry' },
    { label: 'Monster Mango', value: 'monster-mango' },
    { label: 'Piña Colada', value: 'pina-colada' }
  ];

  public static BENCHMARK_CATEGORY_OPTIONS = [
    { label: 'Average Unit Volume', value: 'AUV' },
    { label: 'Event Count/Unit', value: 'EPU' },
    { label: 'Event Sales Average', value: 'ESA' }
  ];

  public static MANAGE_EVENT_DEFAULT_FILTER_OPTIONS = [
    { label: 'Events Only', value: 'ONLY_EVENTS' },
    { label: 'Events and Tasks', value: 'EVENTS_AND_TASKS' }
  ];

  public static ENQUIRY_TYPE_OPTIONS = [
    { label: 'Select', value: '' },
    { label: 'Booking Form', value: 'booking-form' },
    { label: 'No Reply', value: 'no-reply' },
  ];
  
  public static BeverlyMENUITEMS = [
    {
        "label": "By the Dozen",
        "value": "by-the-dozen",
        "price": 20,
        "enabled": true,
        "type": {
            "label": "Catering/Delivery",
            "value": "catering-delivery"
        }
    },
    {
        "label": "Party Platter or Tray",
        "value": "party-platter-or-tray",
        "price": 50,
        "enabled": true,
        "type": {
            "label": "Catering/Delivery",
            "value": "catering-delivery"
        }
    },
    {
        "label": "2 Cookies",
        "value": "2-cookies",
        "price": 4,
        "enabled": true,
        "type": {
            "label": "Cookies",
            "value": "cookies"
        }
    },
    {
        "label": "4 Cookies",
        "value": "4-cookies",
        "price": 7,
        "enabled": true,
        "type": {
            "label": "Cookies",
            "value": "cookies"
        }
    },
    {
        "label": "6 Cookies",
        "value": "6-cookies",
        "price": 10,
        "enabled": true,
        "type": {
            "label": "Cookies",
            "value": "cookies"
        }
    },
    {
        "label": "1 Scoop",
        "value": "1-scoop",
        "price": 3,
        "enabled": true,
        "type": {
            "label": "Ice Cream",
            "value": "ice-cream"
        }
    },
    {
        "label": "2 Scoops",
        "value": "2-scoops",
        "price": 5,
        "type": {
            "label": "Ice Cream",
            "value": "ice-cream"
        }
    },
    {
        "label": "2 Cookies + 1 Scoop",
        "value": "ann-wich",
        "price": 7,
        "type": {
            "label": "Ann-wich",
            "value": "ann-wich"
        }
    },
    {
        "label": "Sprinkles",
        "value": "sprinkles",
        "price": 1,
        "enabled": true,
        "type": {
            "label": "Extras",
            "value": "extras"
        }
    },
    {
        "label": "Chocolate Drizzle",
        "value": "chocolate-drizzle",
        "price": 1,
        "enabled": true,
        "type": {
            "label": "Extras",
            "value": "extras"
        }
    },
    {
        "label": "Chocolate Chips",
        "price": 1,
        "type": {
            "value": "extras",
            "label": "Extra"
        },
        "value": "chocolate-chips",
        "enabled": true
    }
  ];

  public static COOKIESFLAVORS = [
    { label: 'Chocolate Chip', value: 'chocolate-chip' },
    { label: 'Snickerdoodle', value: 'snickerdoodle' },
    { label: 'Double Chocolate Chunk', value: 'double-chocolate-chunk' },
    { label: 'M&M', value: 'm-and-m' },
    { label: 'Carnival', value: 'carnival' },
    { label: 'Peanut Butter', value: 'peanut-butter' },
    { label: 'Old Fashioned Sugar', value: 'old-fashioned-sugar' },
    { label: 'Oatmeal Raisin', value: 'oatmeal-raisin' },
    { label: 'White Chocolate Macadamia Nut', value: 'white-chocolate-macadamia-nut' },
    { label: 'Red Velvet', value: 'red-velvet' },
  ];

  public static ICECREAMFLAVORS = [
    { label: 'Vanilla', value: 'vanilla' },
    { label: 'Chocolate', value: 'chocolate' },
    { label: 'Strawberry', value: 'strawberry' },
  ];

  public static ADDITIONALCOOKIESFLAVORS = [
    { label: 'March/April: Heath Bar Crunch', value: 'march-april' },
    { label: 'May/June: Lemon Cooler', value: 'may-june' },
    { label: 'July/August: Salted Caramel Churro', value: 'july-august' },
    { label: 'Sept/Oct: Pumpkin Spice', value: 'sept-oct' },
    { label: 'Nov/Dec: Chocolate Peppermint', value: 'nov-dec' },
    
  ];
  
}
